import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { Router,ActivatedRoute, NavigationEnd } from '@angular/router';
import { Config } from 'src/app/config/constants';
import { DatePipe } from '@angular/common';
import { BaseService } from 'src/app/core/services/base.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-mga-details',
  templateUrl: './mga-details.component.html',
  styleUrls: ['./mga-details.component.scss'],
  providers: [DatePipe],
})
export class MgaDetailsComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;
  hidecircle:boolean=true;
  agentcbtn:boolean=true;
  showdocuments: boolean = false;
  showemailErrorMsg: boolean;
  deleteModal: boolean=false;
  deleteModal2: boolean=false;
  deleteModal3: boolean=false;
  deleteModal4: boolean=false;
  showemailErrorMsgone: boolean;
  showlicpErrorMsgone: boolean;
  showlictErrorMsgone:boolean;
  showdateErrorMsg: boolean;
  showdateErrorMsgEffectiveDate: boolean=false;
  Id: any;
  id: any;
  dropdownSettings={};
  Url: any;
  dateModified: string;
  dateCreated: string;
  modifiedbyname: any;
  Createdbyname: any;
  leadStatusStage: any;
  agentNurture: any;
  licencesTypes: any;
  urlSafe: any;
  contractName: any;
  showdocumentapprovebtn: boolean=false;
  personalDate: any;
  uploadDate: any;
  signedDate: any;
  onlinetDate: any;
  personalName: any;
uploadName: any;
signedName: any;
onlinetName: any;
  pageValue: any;
  leadPageNo: any = 0;
  incompletedpi: boolean =false;
  newAttribute: any = {};
  FileDataListLic: any;
  provienceList: any;
  MyTravelLinkRequest: any;
  provinceArray=[];
  getDocuments=[];
  getLicences=[];
  getLicences1=[]
  getVoidCheck=[];
  primaryAddressProvince1: any;
  primaryAddressProvince2: any;
  primaryAddressProvince3: any;
  primaryAddressProvince4: any;
  primaryAddressProvince5: any;
  primaryAddressProvince6: any;
  primaryAddressProvince7: any;
  primaryAddressProvince8: any;
  primaryAddressProvince9: any;
  primaryAddressProvince10: any;
  primaryAddressProvince11: any;
  primaryAddressProvince12: any;
  EOexpiryDate: any;
  
  EOexpiryDate1: any;
  EOexpiryDate2: any;
  EOexpiryDate3: any;
  EOexpiryDate4: any;
  EOexpiryDate5: any;
  EOexpiryDate6: any;
  EOexpiryDate7: any;
  EOexpiryDate8: any;
  EOexpiryDate9: any;
  EOexpiryDate10: any;
  EOexpiryDate11: any;
  EOexpiryDate12: any;
  ResidentProvince1: any;
  residentLicense: string;
  residentLicense1: string;
  ResidentLicenseExpiryDate: any;
  dncStatusval=[];
  jumpStart: any;
  specialBonus: any;
  checkFlagCASLdata: boolean=false;
  licencesType=[]
  showAgency: boolean=false;
  leadId: any;
agencyId: any;
  description: any;
  ResidentProvince: any;
  mgaId: any;
  editMGAShortName: boolean=false;
  callMgaAPI: boolean=false;
  isOverWriteEO: boolean=false;
  documentType: any;
  BankInfo :boolean = false;
  EditBankInfo :boolean = false;
  btnPopupName ="Save"
  btncancelPopupName ="Cancel"
  confirmaccountNo: any;
  confirmaccountNoErrMsg: boolean=false;
  transitNo: any;
  financialInstitutionNo: any ;
  accountNo: any;
  transitNoErrMsg: boolean=false;
  financialInstitutionNoErrMsg: boolean=false;
  accountNoErrMsg: boolean=false;
  todayDate: Date;
  bankNm: any;
  holdeNm: any;
  holderNm: any;
  branchAdr: any;
  transitNm: any;
  financialInstNumber: any;
  accNm: any;
  confirmAccNo: any;
  bankName : any;
  corporateLicType: any=[];
  individualLicType: any=[];
  showAgentCodeButton: boolean=false;
  showDropDown:boolean=false;
  showDropDown1:boolean=false;
  getAgentCodeDetails: any=[];
  primaryAgentCodeShow: any;
  showAgentCodeCount:any=0;
  agentNurtureStatus: any;
  effectiveDateLic:any;
  effectiveDate:any;
  oricid: any;
  brokerLinkMGA: any=[];
  mgaIndex: any=0;
  agencyIndex: any=0;
  brokerLinkMGAAgency: any=[];
  lastTrainingDate: any;
  otpTimerDisplaySIN: string = '';
  otpTimerSIN: any;
  remainingSecondsSIN: number = 300;
  isOtpExpiredSIN: boolean = false;
  constructor(public user: UserService, public config: Config, public router: Router,private DatePipe:DatePipe,private route: ActivatedRoute,private base: BaseService,private toastr: ToastrService) {
    this.todayDate = new Date();    
    this.leadId = this.route.snapshot.paramMap.get("id");
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      console.log('URL changed to:', event.urlAfterRedirects);
      // You can perform your actions here, e.g., reloading the page
      window.location.reload();
    });
   }
 
  ngOnInit(): void {
    this.leadId = this.route.snapshot.paramMap.get("id");
    sessionStorage.setItem('leadId',this.leadId);
    window.scrollTo(0, 0);
    var testCheck=sessionStorage.getItem('selectedMgaIdDoc');
    if(testCheck =='true'){
      this.openTabs(1)
    }
    this.allMgaData=JSON.parse(sessionStorage.getItem("allMgaData"));
    this.Id  = sessionStorage.getItem('selectedMgaId');
    this.mgaId  = sessionStorage.getItem('selectedMgaIdNew');
    //  this.leadPageNo =  sessionStorage.getItem('leadPage');
     var filterState=localStorage.getItem('filterStatus');
    var filterIndex=localStorage.getItem('filterStatusIndex');
    this.leadId = sessionStorage.getItem('leadId');
    // if(filterState != undefined){
    //   this.testFilter(filterState,filterIndex)
    // }else{
    //   this.getLeadListData();
    // }
    
    //  if(this.leadPageNo != null || undefined){
    //  this.getMgaUnderLeadsByPage();
    //  }
    //  else if(filterState != undefined){
    //   this.test(filterState,filterIndex)
    //  }
    //  else{
      this.getMgaUnderLeads();
    //  }
    this.getLastTrainingDate()
    this.getProvince();
    this.getLeadTags();
    this.getDocument();
    this.getLeadContractSign();
    this.getLeadInfo();
    this.getDataOfUnderwriterLeadAgentCode();
    this.dropdownSettings = { 
      singleSelection: false, 
      text:"Select",
      selectAllText:'Select All',
      unSelectAllText:'UnSelect All',
      enableSearchFilter: true,
      classes:"myclass custom-class",
      badgeShowLimit: 50

    };
    this.getMiscDocument();
  }
  onInfo(data){
    
    data
    this.contractDetails
     this.contractName = data.name
    this.urlSafe=data.fileUrl
   }
  getLeadInfo(){
    this.user.getLeadInfoNew().pipe()
    .subscribe(
        data => {
       
          this.corporateLicType=[]
          this.individualLicType=[]
          // this.provienceList=[];
          // this.provienceList=data.data.provinces;
          // this.provinceArray=data.data.provinces;
          
          this.licencesType = data.data.licencesTypes;  
          for(let i=0; i<this.licencesType.length; i++){
            var testOVr = this.licencesType[i].toLowerCase();
            if (testOVr.indexOf('corporate') > -1){
              this.corporateLicType.push(this.licencesType[i])
            }else{
              this.individualLicType.push(this.licencesType[i])
            }
          } 
        },error=>{
          //  if(this.baseservice.handleError(error)){
             //handle Exception from Server 404,401
            if(error.status == 400 || error.status==417){
                this.error=error.error.data;
               
             }
             else{
               
               this.error="Something went wrong. Please check username and password.";
             }
        
            },()=>{});
   
  }
  onItemSelect(item: any) {
      }
      OnItemDeSelect(item: any) {
      }
      onSelectAll(items: any) {
      }
      onDeSelectAll(items: any) {
      }

  tabs = [
    { active: 'active', tabcontent: 'tabcontent' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    
    ];
    openTabs(index){
      this.reset();
      this.tabs[index].active = 'active';
      this.tabs[index].tabcontent = 'tabcontent';
      if(index==0)
      {
        this.hidecircle=true;
    
      }
      else
      {
        this.hidecircle=false;
    
      }
    if(index==2 || index==3)
    {
      this.agentcbtn=false;
    }
    else
    {
      this.agentcbtn=true;
    
    }
    }
    reset() {
      for (let i = 0; this.tabs.length > i; i++) {
      this.tabs[i].active = '';
      this.tabs[i].tabcontent = 'hide';
      }
      }
      tabs1 = [
        { active1: 'active1', tabcontent1: 'tabcontent1' },
        { active1: '', tabcontent1: 'hide' },
        { active1: '', tabcontent1: 'hide' },
        { active1: '', tabcontent1: 'hide' },
        { active1: '', tabcontent1: 'hide' },
        { active1: '', tabcontent1: 'hide' },
        { active1: '', tabcontent1: 'hide' },
        { active1: '', tabcontent1: 'hide' },
        
        ];
        openTabs1(index){
          this.reset1();
          this.tabs1[index].active1 = 'active1';
          this.tabs1[index].tabcontent1 = 'tabcontent1';
          
        }
        
        
        reset1() {
        for (let i = 0; this.tabs1.length > i; i++) {
        this.tabs1[i].active1 = '';
        this.tabs1[i].tabcontent1 = 'hide';
        }
        }
        tabs2 = [
          { active2: 'active2', tabcontent2: 'tabcontent2' },
          { active2: '', tabcontent2: 'hide' },
          { active2: '', tabcontent2: 'hide' },
          { active2: '', tabcontent2: 'hide' },
          { active2: '', tabcontent2: 'hide' },
          { active2: '', tabcontent2: 'hide' },
          { active2: '', tabcontent2: 'hide' },
          { active2: '', tabcontent2: 'hide' },
          
          ];
        openTabs2(index){
          this.reset2();
          this.reset21();
          this.reset22();
          this.tabs2[index].active2 = 'active2';
          this.tabs2[index].tabcontent2 = 'tabcontent2';
          
        }
    
        reset2() {
          for (let i = 0; this.tabs2.length > i; i++) {
          this.tabs2[i].active2 = '';
          this.tabs2[i].tabcontent2 = 'hide';
          }
          }
MgaDataSelectedLead: any;
personalinfo: any;
isCompletedPI: boolean;
isCompletedPI1: boolean;
isUploaddoc: boolean;
isCompleted: boolean;
isInprogressUD: boolean;
isPersonalInfo: boolean=false;
  completed: boolean=false;
  incompleted0: boolean=false;
  isPending: boolean=false;
  isUploadDocument: boolean=false;
  incompleted1: boolean=false;
  isPendingDoc: boolean=false;
  isSignAgreement: boolean=false;
  isPendingContract: boolean=false;
  incompleted2: boolean=false;
  isOnlineTraining: boolean=false;
  isOnlineTraining1: boolean=false;
  incompleted3: boolean=false;
  isInprogressContract: boolean=false;
  isInprogressTraining: boolean=false;
  isPendingTraining: boolean=false;
  isPending1: boolean=false;
  isprimarySelected: boolean =false;
  allMgaData=[];
      getMgaUnderLeads() {
        // this.user.getMGA().pipe()
        //   .subscribe(
        //     data => {
          this.user.getLeadInfoId(this.leadId).pipe()
.subscribe(
    data => {
      
              this.blockUI.stop();
              if(data.data != null){
                this.MgaDataSelectedLead=[];
                this.pageValue = data.data.currentPageNumber
                // for(let i=0; i<data.data.length;i++){
                //   this.allMgaData.push(data.data.leads[i]);
                //   if(this.Id==this.allMgaData[i].id){   // matched Id
                  this.MgaDataSelectedLead = data.data
                //   }else{
                //     this.leadPageNo = this.leadPageNo+1;
                //     this.getMgaUnderLeadsByPage()
                //   }
                // }
                // this.brokerLinkMGA = data.data.brokerLinkMGAs;
                const filteredItems = data.data.brokerLinkMGAs.filter(item => item.isCompnaySignUp === true);

                // Step 2: Remove duplicates within the filtered items based on agencyId
                const uniqueFilteredItems = filteredItems.filter((item, index, self) => 
                  item.agencyId !== null &&
                  index === self.findIndex(i => i.agencyId === item.agencyId)
                );
                
                // Step 3: Remove items that already exist in brokerLinkMGAAgency (to avoid pushing duplicates)
                const nonDuplicateItems = uniqueFilteredItems.filter(item =>
                  !this.brokerLinkMGAAgency.some(existingItem => existingItem.agencyId === item.agencyId)
                );
                
                // Step 4: Push the non-duplicate items into brokerLinkMGAAgency
                this.brokerLinkMGAAgency.push(...nonDuplicateItems);
                
                
                data.data.brokerLinkMGAs.forEach(item => {
                    // Check if the mgaId already exists in this.brokerLinkMGA
                    const exists = this.brokerLinkMGA.some(existingItem => existingItem.mgaId === item.mgaId);
                  
                    // If it doesn't exist, push it into this.brokerLinkMGA
                    if (!exists) {
                      this.brokerLinkMGA.push(item);
                    }
                  });
                 console.log( data.data)
                this.personalinfo = data.data;
                
                if (this.personalinfo.stagesViews != null || undefined) {
                  sessionStorage.setItem('stagesViews', JSON.stringify(this.personalinfo.stagesViews))
                  if (this.personalinfo.stagesViews[0].isCompleted === false && this.personalinfo.stagesViews[0].isApproved === false) {
                    this.isCompletedPI = false
                    this.isCompletedPI1 = false
                    this.incompletedpi=false;

                  }
                  else if (this.personalinfo.stagesViews[0].isCompleted === true && this.personalinfo.stagesViews[0].isApproved === false) {
                   this.isCompletedPI = false
                   this.isCompletedPI1 = false
                   this.incompletedpi = true;

                  }
                  else {
                    this.isCompletedPI = true;
                    this.isCompletedPI1 = true;
                  }
                  if (this.personalinfo.stagesViews[1].isCompleted === true && this.personalinfo.stagesViews[1].isApproved === true) {
                    this.isUploaddoc = true;
                    this.isCompleted = true;
                  }
                 else if (this.personalinfo.stagesViews[1].isCompleted === true && this.personalinfo.stagesViews[1].isApproved === false) {
                    this.isUploaddoc = false;
                    this.isCompleted = true;
                    this.isInprogressUD = true;
                   
                  }
                  else{
                    this.isUploaddoc = false;
                    this.isCompleted = false;
                  }
                  
                }
              }

              // for(let i=0; i<this.MgaDataSelectedLead.length; i++){
                
                
                if (this.MgaDataSelectedLead.stagesViews[1].isEditable === true ){
                  this.showdocumentapprovebtn = true;
                }
                if(this.MgaDataSelectedLead.stagesViews[0].isCompleted === true && this.MgaDataSelectedLead.stagesViews[0].isApproved===true){
                  this.incompletedpi =false;
                  this.isPending1=false;
                  this.isPersonalInfo = true;
            
                  }
                  if(this.MgaDataSelectedLead.stagesViews[0].isCompleted === false && this.MgaDataSelectedLead.stagesViews[0].isApproved===false){
              
                this.isPending1=true;
                this.incompletedpi=false;
                this.isPersonalInfo = false;
       
                  }
                  if(this.MgaDataSelectedLead.stagesViews[0].isCompleted === true && this.MgaDataSelectedLead.stagesViews[0].isApproved===false){
                this.incompletedpi =true;
                this.isPending1=false;
                this.isPersonalInfo = false;
             
                  }
               
                if(this.MgaDataSelectedLead.stagesViews[1].isCompleted === true && this.MgaDataSelectedLead.stagesViews[1].isApproved===true){
                  this.isUploadDocument=true;
                 this.incompleted1=false;
                  this.isPendingDoc=false;
                  }
                  if(this.MgaDataSelectedLead.stagesViews[1].isCompleted === false && this.MgaDataSelectedLead.stagesViews[1].isApproved===false){
                    this.incompleted1=false;
                    this.isPending=true;
                    this.isPendingDoc=true;
            
                  }
                if(this.MgaDataSelectedLead.stagesViews[2].isCompleted === true && this.MgaDataSelectedLead.stagesViews[2].isApproved===true){
                    this.isSignAgreement=true;
                    this.isPendingContract=false;
                    this.isInprogressContract=false
                  }
                  if(this.MgaDataSelectedLead.stagesViews[2].isCompleted ===false  && this.MgaDataSelectedLead.stagesViews[2].isApproved===false){
                    this.incompleted2=false;
                    this.isPending=true;
                    this.isPendingContract=true
            
                  }
                  if(this.MgaDataSelectedLead.stagesViews[3].isCompleted === true && this.MgaDataSelectedLead.stagesViews[3].isApproved===true){
                    this.isOnlineTraining = true;
                    this.isOnlineTraining1 = false;
                    this.completed=true;
                  }
                  if(this.MgaDataSelectedLead.stagesViews[3].isCompleted === false && this.MgaDataSelectedLead.stagesViews[3].isApproved === false){
                    this.incompleted3 =false;
                    this.isPending=true;
                    this.isPendingTraining=true;
            
                  }
                  if(this.MgaDataSelectedLead.stagesViews[1].isCompleted === true && this.MgaDataSelectedLead.stagesViews[1].isApproved===false){
                    this.incompleted1=true;
                    this.isUploadDocument=false;
                   this.isPendingDoc=false;
            
                  }
                  if(this.MgaDataSelectedLead.stagesViews[2].isCompleted === true && this.MgaDataSelectedLead.stagesViews[2].isApproved===false){
                    this.isInprogressContract=true;
                    this.isPendingContract=false;
                    this.isSignAgreement=false;
            
                  }
                  if(this.MgaDataSelectedLead.stagesViews[3].isCompleted === true && this.MgaDataSelectedLead.stagesViews[3].isApproved===false){
                    this.isInprogressTraining=true;
                    this.isPendingTraining=false;
                    this.isOnlineTraining=false;
                  }
                
                this.personalDate=this.DatePipe.transform(this.MgaDataSelectedLead.stagesViews[0].updatedAt,'MM/dd/yyyy hh:mm a');
                this.uploadDate=this.DatePipe.transform(this.MgaDataSelectedLead.stagesViews[1].updatedAt,'MM/dd/yyyy hh:mm a');
                this.signedDate=this.DatePipe.transform(this.MgaDataSelectedLead.stagesViews[2].updatedAt,'MM/dd/yyyy hh:mm a');
                this.onlinetDate=this.DatePipe.transform(this.MgaDataSelectedLead.stagesViews[3].updatedAt,'MM/dd/yyyy hh:mm a');
                this.personalName=this.MgaDataSelectedLead.stagesViews[0].lastModifiedBy;
                this.uploadName=this.MgaDataSelectedLead.stagesViews[1].lastModifiedBy;
                this.signedName=this.MgaDataSelectedLead.stagesViews[2].lastModifiedBy;
                this.onlinetName=this.MgaDataSelectedLead.stagesViews[3].lastModifiedBy;
                // }
                this.getData();
            }, error => {
              
            }, () => { });
      }
      getMgaUnderLeadsByPage() {
        this.blockUI.stop();
        this.user.getMGAPage(this.leadPageNo).pipe()
          .subscribe(
            data => {
              
              if(data.data.leads != null){
                this.MgaDataSelectedLead=[];
                this.pageValue = data.data.currentPageNumber
                for(let i=0; i<data.data.leads.length;i++){
                  // this.allMgaData.push(data.data.leads[i]);
                  if(this.Id==this.allMgaData[i].id){   // matched Id
                  this.MgaDataSelectedLead = this.allMgaData[i]
                  }
                  // else{
                  //   return this.getMgaUnderLeads();
                  // }
                }
                // console.log(this.MgaDataSelectedLead)
                this.personalinfo = data.data.leads;
                
                if (this.personalinfo.stagesViews != null || undefined) {
                  sessionStorage.setItem('stagesViews', JSON.stringify(this.personalinfo.stagesViews))
                  if (this.personalinfo.stagesViews[0].isCompleted === false && this.personalinfo.stagesViews[0].isApproved === false) {
                    this.isCompletedPI = false
                    this.isCompletedPI1 = false
                    this.incompletedpi=false;
                  }
                  else if (this.personalinfo.stagesViews[0].isCompleted === true && this.personalinfo.stagesViews[0].isApproved === false) {
                    this.isCompletedPI = false
                    this.isCompletedPI1 = false
                    this.incompletedpi = true;
                  }
                  else {
                    this.isCompletedPI = true;
                    this.isCompletedPI1 = true;
                  }
                  if (this.personalinfo.stagesViews[1].isCompleted === true && this.personalinfo.stagesViews[1].isApproved === true) {
                    this.isUploaddoc = true;
                    this.isCompleted = true;
                  }
                 else if (this.personalinfo.stagesViews[1].isCompleted === true && this.personalinfo.stagesViews[1].isApproved === false) {
                    this.isUploaddoc = false;
                    this.isCompleted = true;
                    this.isInprogressUD = true;
                  }
                  else{
                    this.isUploaddoc = false;
                    this.isCompleted = false;
                  }
                  
                }
              }

              if(this.MgaDataSelectedLead!=null){
                
                if (this.MgaDataSelectedLead.stagesViews[1].isEditable === true ){
                  this.showdocumentapprovebtn = true;
                }
                if(this.MgaDataSelectedLead.stagesViews[0].isCompleted === true && this.MgaDataSelectedLead.stagesViews[0].isApproved===true){
                  this.isPersonalInfo = true;
                  this.completed=true;
                  this.isPending1=false;
                  }
                  if(this.MgaDataSelectedLead.stagesViews[0].isCompleted === true && this.MgaDataSelectedLead.stagesViews[0].isApproved===false){
                    this.isPersonalInfo = false;
                    this.isPending1=false;
            
                  }
                  if(this.MgaDataSelectedLead.stagesViews[0].isCompleted === false && this.MgaDataSelectedLead.stagesViews[0].isApproved===false){
                this.incompleted0 =false;
                this.isPending1=true;
                this.isPersonalInfo = false;
                  }
               
                if(this.MgaDataSelectedLead.stagesViews[1].isCompleted === true && this.MgaDataSelectedLead.stagesViews[1].isApproved===true){
                  this.isUploadDocument=true;
                 this.incompleted1=false;
                  this.isPendingDoc=false;
                  }
                  if(this.MgaDataSelectedLead.stagesViews[1].isCompleted === false && this.MgaDataSelectedLead.stagesViews[1].isApproved===false){
                    this.incompleted1=false;
                    this.isPending=true;
                    this.isPendingDoc=true;
            
                  }
                if(this.MgaDataSelectedLead.stagesViews[2].isCompleted === true && this.MgaDataSelectedLead.stagesViews[2].isApproved===true){
                    this.isSignAgreement=true;
                    this.isPendingContract=false;
                    this.isInprogressContract=false
                  }
                  if(this.MgaDataSelectedLead.stagesViews[2].isCompleted ===false  && this.MgaDataSelectedLead.stagesViews[2].isApproved===false){
                    this.incompleted2=false;
                    this.isPending=true;
                    this.isPendingContract=true
            
                  }
                  if(this.MgaDataSelectedLead.stagesViews[3].isCompleted === true && this.MgaDataSelectedLead.stagesViews[3].isApproved===true){
                    this.isOnlineTraining = true;
                    this.isOnlineTraining1 = false;
                    this.completed=true;
                  }
                  if(this.MgaDataSelectedLead.stagesViews[3].isCompleted === false && this.MgaDataSelectedLead.stagesViews[3].isApproved === false){
                    this.incompleted3 =false;
                    this.isPending=true;
                    this.isPendingTraining=true;
            
                  }
                  
                  if(this.MgaDataSelectedLead.stagesViews[1].isCompleted === true && this.MgaDataSelectedLead.stagesViews[1].isApproved===false){
                    this.incompleted1=true;
                    this.isUploadDocument=false;
                   this.isPendingDoc=false;
            
                  }
                  if(this.MgaDataSelectedLead.stagesViews[2].isCompleted === true && this.MgaDataSelectedLead.stagesViews[2].isApproved===false){
                    this.isInprogressContract=true;
                    this.isPendingContract=false;
                    this.isSignAgreement=false;
            
                  }
                  if(this.MgaDataSelectedLead.stagesViews[3].isCompleted === true && this.MgaDataSelectedLead.stagesViews[3].isApproved===false){
                    this.isInprogressTraining=true;
                    this.isPendingTraining=false;
                    this.isOnlineTraining=false;
                  }
                }
                this.getData();
            }, error => {
              
            }, () => { });
      }

firstName: any;
agencyName: any;
firstSignUpDate: any;
caslOptOut: any;
assignedToFirstname:any;
assignedToLastname:any;
type: any;
primaryAddressLine: any;
commitionTo: any;
primaryAddressCity: any;
mgaName: any;
primaryAddressProvince: any;
agencyCode: any;
primaryAddressPostalCode: any;
agencyStatus: any;
businessPhone: any;
alternativePhone: any;
primaryEmailAddress: any;
website: any;
langauges: any;
title: any;
countTrainig: any;
tagsArray=[];
PLicensedArray=[];
salutation: any;
middleName: any;
lastName: any;
leadStatus: any;
primaryAddressPostalCountry: any;
alternativeAddressLine: any;
alternativeAddressCity:any;
leadProvinces=[];
provinceLicencesarray=[];
alternativeAddressProvince: any;
alternativeAddressPostalCode: any;
alternativeAddressPostalCountry: any;
companyName: any;
countCalls: any;
myTravelLink: any;
countTasks: any;
dncStatus: any;
positionTitle: any;
workPhone:any;
workPhoneExtension: any;
phoneOther: any;
mobile: any;
fax: any;
phoneHome: any;
leadSource: any;
ciprNumber: any;
productsSelling: any;
password: any;
EOLicenseNo: any;
consentStatus: any;
proofOfConsent: any;
consentDate: any;
adminOnly: any;
isCompanyRegister:boolean=false;
myTravelLinkRequest:any;
showAgencyName:any;
// EOexpiryDate: any;
      getData(){
        this.Createdbyname= this.MgaDataSelectedLead.createdBy;
        this.modifiedbyname= this.MgaDataSelectedLead.lastModifiedBy;
        this.agencyId=this.MgaDataSelectedLead.agencyId
        this.dateCreated = this.DatePipe.transform(this.MgaDataSelectedLead.createdAt, 'MM/dd/yyyy hh:mm a');
        this.dateModified = this.DatePipe.transform(this.MgaDataSelectedLead.updatedAt,'MM/dd/yyyy hh:mm a');
        this.leadStatusStage =this.MgaDataSelectedLead.stageStatus;
        this.leadStatus=this.MgaDataSelectedLead.leadStatus;
        this.dncStatusval=this.MgaDataSelectedLead.dncStatus
        // this.ciprNumber = this.MgaDataSelectedLead.ciprNumber;
        this.agentNurture = this.MgaDataSelectedLead.agentNurtureStatus;
        this.lastName=this.MgaDataSelectedLead.lastName;
        this.firstName=this.MgaDataSelectedLead.firstName;
        this.middleName=this.MgaDataSelectedLead.middleName;
        this.agencyName=this.MgaDataSelectedLead.mga.mgaName;
        this.mgaName=this.MgaDataSelectedLead.mga.mgaName;
        this.firstSignUpDate = this.DatePipe.transform(this.MgaDataSelectedLead.mga.firstSignUpDate,'MM/dd/yyyy hh:mm a');
       // this.firstSignUpDate=this.MgaDataSelectedLead.mga.firstSignUpDate;
        // this.caslOptOut=this.MgaDataSelectedLead.caslOptOut;
        this.assignedToFirstname=this.MgaDataSelectedLead.assignedTo.firstName;
        this.assignedToLastname=this.MgaDataSelectedLead.assignedTo.assignedToLastname;
        this.type=this.MgaDataSelectedLead.type;
        this.salutation=this.MgaDataSelectedLead.salutation;
        this.primaryAddressLine=this.MgaDataSelectedLead.primaryAddressLine;
        this.commitionTo=this.MgaDataSelectedLead.commissionTo;
        this.primaryAddressCity=this.MgaDataSelectedLead.primaryAddressCity;
        // this.mgaName=this.MgaDataSelectedLead.mga.mgaName;
        this.mgaName = this.MgaDataSelectedLead.mga.mgaShortName;
        if(this.mgaName==null || this.mgaName==undefined ){
         this.mgaName = this.MgaDataSelectedLead.mga.mgaName;
        }
        this.primaryAddressProvince=this.MgaDataSelectedLead.primaryAddressProvince;
        this.agencyCode=this.MgaDataSelectedLead.mga.agencyCode;
        this.primaryAddressPostalCode=this.MgaDataSelectedLead.primaryAddressPostalCode;
        this.agencyStatus=this.MgaDataSelectedLead.mga.agencyStatus;
        this.businessPhone=this.MgaDataSelectedLead.mga.businessPhone;
        this.alternativePhone=this.MgaDataSelectedLead.mga.alternativePhone;
        this.primaryEmailAddress=this.MgaDataSelectedLead.leadEmail[0].email;
        this.website=this.MgaDataSelectedLead.website;
        this.alternativeAddressLine=this.MgaDataSelectedLead.alternativeAddressLine;
        this.alternativeAddressCity=this.MgaDataSelectedLead.alternativeAddressCity;
        this.leadProvinces=this.MgaDataSelectedLead.leadProvinces;
        this.alternativeAddressProvince=this.MgaDataSelectedLead.alternativeAddressProvince;
        this.alternativeAddressPostalCode=this.MgaDataSelectedLead.alternativeAddressPostalCode;
      
        this.showAgency = this.MgaDataSelectedLead.isCompanyRegister;
        if(this.primaryAddressPostalCode){
          this.primaryAddressPostalCode=this.primaryAddressPostalCode.toUpperCase();
           if(this.primaryAddressPostalCode.length>3){
             this.primaryAddressPostalCode=this.primaryAddressPostalCode.replace(/.{3}$/,' $&');
      
           }
         }
         if(this.alternativeAddressPostalCode){
          this.alternativeAddressPostalCode=this.alternativeAddressPostalCode.toUpperCase();
           if(this.alternativeAddressPostalCode.length>3){
             this.alternativeAddressPostalCode=this.alternativeAddressPostalCode.replace(/.{3}$/,' $&');
      
           }
         }
        this.alternativeAddressPostalCountry=this.MgaDataSelectedLead.alternativeAddressPostalCountry;
        this.companyName=this.MgaDataSelectedLead.companyName;
        this.showAgencyName=this.MgaDataSelectedLead.agencyName;
        this.isCompanyRegister=this.MgaDataSelectedLead.isCompanyRegister;
        this.myTravelLinkRequest=this.MgaDataSelectedLead.myTravelLinkRequest
        this.countCalls=this.MgaDataSelectedLead.countCalls;
        this.myTravelLink=this.MgaDataSelectedLead.myTravelLink;
        this.countTasks=this.MgaDataSelectedLead.countTasks;
        this.dncStatus=this.MgaDataSelectedLead.dncStatus;
        this.positionTitle=this.MgaDataSelectedLead.positionTitle;
        this.workPhone=this.MgaDataSelectedLead.workPhone;
        this.workPhoneExtension=this.MgaDataSelectedLead.workPhoneExtension;
        this.phoneOther=this.MgaDataSelectedLead.phoneOther;
        this.mobile=this.MgaDataSelectedLead.mobile;
        this.tags=this.MgaDataSelectedLead.tags;
        this.fax=this.MgaDataSelectedLead.fax;
        this.ciprNumber=this.MgaDataSelectedLead.ciprNumber;
        this.phoneHome=this.MgaDataSelectedLead.phoneHome;
        this.leadSource=this.MgaDataSelectedLead.leadSource;
        this.productsSelling=this.MgaDataSelectedLead.productsSelling;
        this.password=this.MgaDataSelectedLead.password;
        this.primaryAddressPostalCountry=this.MgaDataSelectedLead.primaryAddressPostalCountry;
        this.langauges=this.MgaDataSelectedLead.langauges;
        this.title=this.MgaDataSelectedLead.mga.title;
        this.countTrainig=this.MgaDataSelectedLead.mga.countTrainig;
        this.primaryContactFirstName=this.MgaDataSelectedLead.mga.primaryContactFirstName;
        this.primaryContactLastName=this.MgaDataSelectedLead.mga.primaryContactLastName;
        this.primaryContactPhone=this.MgaDataSelectedLead.mga.primaryContactPhone;
        this.licencesTypes = this.MgaDataSelectedLead.licencesTypes;    
        // this.licencesTypes = this.MgaDataSelectedLead.licencesTypes;     
        this.MyTravelLinkRequest=this.MgaDataSelectedLead.myTravelLinkRequest;
        this.jumpStart=this.MgaDataSelectedLead.jumpStart
  this.specialBonus=this.MgaDataSelectedLead.specialBonus
this.consentStatus=this.MgaDataSelectedLead.consentStatus
this.consentDate=this.DatePipe.transform(this.MgaDataSelectedLead.consentDate,'MM/dd/yyyy');
this.checkFlagCASLdata=this.MgaDataSelectedLead.caslOptOut;
this.provinceLicencesarray=this.MgaDataSelectedLead.lincences
this.agentNurtureStatus=this.MgaDataSelectedLead.agentNurtureStatus;
if(this.checkFlagCASLdata==true){
  this.caslOptOut="Yes"
}
else{
  this.caslOptOut="No"
}
this.proofOfConsent=this.MgaDataSelectedLead.proofOfConsent
this.adminOnly=this.MgaDataSelectedLead.adminOnly
        if(this.MgaDataSelectedLead.tags != null){
          this.tagsArray=[]
         for(let i=0; i<this.MgaDataSelectedLead.tags.length; i++){
          this.tagsArray.push({"id":this.MgaDataSelectedLead.tags[i],"itemName":this.MgaDataSelectedLead.tags[i]});
        }
      }
      this.PLicensedArray=[];
      for(let i=0; i<this.MgaDataSelectedLead.leadProvinces.length; i++){
        // this.PLicensedArray.push(this.personalinfo.leadProvinces[i].provinces.provinceName);
        this.PLicensedArray.push({"id":this.MgaDataSelectedLead.leadProvinces[i].provinces.id,"itemName":this.MgaDataSelectedLead.leadProvinces[i].provinces.provinceName+'-'+this.MgaDataSelectedLead.leadProvinces[i].provinces.provinceCode});
     }

      }

      primaryContactFirstName: any;
      primaryContactLastName: any;
      primaryContactPhone: any;
      tags=[];
      onSave(){
        if(this.tagsArray != null){
          for(let i=0; i<this.tagsArray.length; i++){
            this.tags.push(this.tagsArray[i].id)
          }
        }
      }

      tagsList=[];
      getLeadTags(){
        this.user.getLeadsTags().pipe()
        .subscribe(
            data => {
           if(data.data.length !=0){
            for(let i=0; i<data.data.length; i++){
             this.tagsList.push({"id":data.data[i].name,"itemName":data.data[i].name});
           }
         }
        },error=>{
         
            },()=>{});
      }

      fileExtensionENO: any;
      fileExtensionErrorENO: boolean = false;
      fileExtensionMessageENO: any;
      fileenoName: string;
      FileDataList: any;
      acceptedExtensions = ["jpg", "jpeg", "png", "pdf", "docx", "JPG", "JPEG", "PNG", "PDF", "DOCX"];
      enofile: File=null;
      enoSizeCheck: boolean=false;
      FileSelect(event) {
        // this.FileDataList=event.target.files;
        // this.fileenoName=this.FileDataList[0].name;
        this.enofile = event.target.files[0];
    if(this.enofile.size>4194304){
      this.enoSizeCheck=true;

      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }else{
      this.enoSizeCheck=false;
      this.showemailErrorMsg=false;
    }
        if (event.target.files.length > 0) {
          this.FileDataList = event.target.files;
          this.fileenoName = this.FileDataList[0].name;
    
          this.fileExtensionENO = this.fileenoName.split('.').pop();
          if (this.isInArray(this.acceptedExtensions, this.fileExtensionENO)) {
            this.fileExtensionErrorENO = false;
            this.fileExtensionMessageENO = ""
    
            this.showemailErrorMsg = this.fileExtensionErrorENO
            this.fileenoName = this.FileDataList[0].name;
          } else {
            this.fileExtensionMessageENO = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
            this.fileExtensionErrorENO = true;
            this.showemailErrorMsg = this.fileExtensionErrorENO
            this.fileenoName = this.fileExtensionMessageENO
    
          }
    
        } else {
          this.showemailErrorMsg = false;
          this.fileenoName = ""
        }
    
      }
      /*- checks if word exists in array -*/
      isInArray(array, word) {
        return array.indexOf(word.toLowerCase()) > -1;
      }

      productPhotofile: any;
      expiryDate: any;
      policyNumber: any;
      FileUpload() {
        if(this.FileDataList!=undefined){
        for (var i = 0; i < this.FileDataList.length; i++) {
          this.productPhotofile = this.FileDataList[i];
          if (this.productPhotofile != null) {
            const formData = new FormData();
            formData.append('file', this.productPhotofile);
            formData.append('expiryDate', this.expiryDate);
            formData.append('effectiveDate', this.effectiveDate);
            formData.append('policyNumber', this.policyNumber);
            var data = sessionStorage.getItem('selectedMgaId')
            formData.append('leadId', data);
            //  this.fileData=formData
            if(this.docId!=null || this.docFileId!=null){
              formData.append('documentId', this.docId)
              formData.append('fileId', this.docFileId)
              }
              if(this.agencyCallEO == true){
              formData.append('agencyId', this.agencyId)
              }
      
            if(this.agencyCallEO == false){
              this.uploadImages(formData)
            }else{
              this.uploadImagesCompany(formData)
            }
            
          }
    
        }
      }else{
        this.overwriteeotest()
            }
      }
      overwriteeotest(){
        // 
        if(this.agencyCallEO==true){
          const formData = new FormData();
          formData.append('expiryDate', this.expiryDate);
          formData.append('effectiveDate', this.effectiveDate);
            formData.append('policyNumber', this.policyNumber);
            var data = this.leadId
            formData.append('leadId', data);
            formData.append('documentId', this.doumentId)
            formData.append('fileId', this.fileeno) 
            formData.append('agencyId', this.agencyId)      
          this.loading = true;
          this.user.submitFormService(this.config.updateEoDOcAgency, formData).subscribe((data: any) => {
            this.expiryDate = "";
            this.effectiveDate = "";
            this.fileeno = "";
            this.fileenoName = "";
            this.policyNumber = "";
            this.finalDocs = data.data;
            this.loading = false;
            this.uploadExpEOPopup=false;
            Swal.fire('', data.message, 'success');
            this.showExpiry = data.data.expiryDate;
            this.showDocumentName = data.data.documentName;
            this.showPolicyNumber = data.data.policyNumber;
            this.getLeadSDocumentAgency(this.agencyId,this.agencyIndex);
            this.uploaddocs()
      
            // this.fileId = data.data.id;
            // this.import();
          }, err => {
            //  this.dismiss();
          });
        }else{
      
        const formData = new FormData();
        formData.append('expiryDate', this.expiryDate);
        formData.append('effectiveDate', this.effectiveDate);
          formData.append('policyNumber', this.policyNumber);
          var data = this.leadId
          formData.append('leadId', data);
          formData.append('documentId', this.doumentId)
          formData.append('fileId', this.fileeno)
        this.user.submitFormService(this.config.OverWriteEO, formData).subscribe((data: any) => {
           
          this.expiryDate = null;
          this.fileeno = "";
          this.fileenoName = "";
          this.policyNumber = "";
          this.finalDocs = data.data;
          this.loading = false;
          this.uploadExpEOPopup=false;
          Swal.fire('', data.message, 'success');
          this.showExpiry = data.data.expiryDate;
          this.showDocumentName = data.data.documentName;
          this.showPolicyNumber = data.data.policyNumber;
          this.getDocument();
          this.uploaddocs()
        }, err => {
        });
      }
      }
      loading: boolean;
      fileeno: any;
      finalDocs: any;
      showExpiry: any;
      showDocumentName: any;
      showPolicyNumber: any;
      async uploadImages(formData: FormData) {
        if(this.addEOFlag==false){         
            this.loading = true;
            this.user.submitFormService(this.config.OverWriteEO, formData).subscribe((data: any) => {
              this.expiryDate = "";
              this.effectiveDate = "";
              this.fileeno = "";
              this.fileenoName = "";
              this.policyNumber = "";
              this.finalDocs = data.data;
              this.loading = false;
              Swal.fire('', data.message, 'success');
              this.showExpiry = data.data.expiryDate;
              this.showDocumentName = data.data.documentName;
              this.showPolicyNumber = data.data.policyNumber;
              this.getDocument();
              this.uploaddocs()
              this.uploadExpEOPopup=false;
              // this.fileId = data.data.id;
              // this.import();
            }, err => {
              //  this.dismiss();
            });      
        }else{
            this.loading = true;
            this.user.submitFormService(this.config.uploadEoOA, formData).subscribe((data: any) => {
              this.expiryDate = "";
              this.effectiveDate = "";
              this.fileeno = "";
              this.fileenoName = "";
              this.policyNumber = "";
              this.finalDocs = data.data;
              this.loading = false;
              
              Swal.fire('', data.message, 'success');
              this.uploadExpEOPopup=false;
              this.showExpiry = data.data.expiryDate;
              this.showDocumentName = data.data.documentName;
              this.showPolicyNumber = data.data.policyNumber;
              this.getDocument();
              this.uploaddocs()
        
              // this.fileId = data.data.id;
              // this.import();
            }, err => {
              //  this.dismiss();
            });
          }       
      }
      async uploadImagesCompany(formData: FormData) {
        if(this.addEOFlagAgency==false){         
          this.loading = true;
          this.user.submitFormService(this.config.updateEoDOcAgency, formData).subscribe((data: any) => {
            this.expiryDate = "";
            this.effectiveDate = "";
            this.fileeno = "";
            this.fileenoName = "";
            this.policyNumber = "";
            this.finalDocs = data.data;
            this.loading = false;
            this.uploadExpEOPopup=false;
            Swal.fire('', data.message, 'success');
            this.showExpiry = data.data.expiryDate;
            this.showDocumentName = data.data.documentName;
            this.showPolicyNumber = data.data.policyNumber;
            this.getLeadSDocumentAgency(this.agencyId,this.agencyIndex);
            this.uploaddocs()
      
            // this.fileId = data.data.id;
            // this.import();
          }, err => {
            //  this.dismiss();
          });
        }else{
          this.loading = true;
          this.user.submitFormService(this.config.uploadEoOACompany, formData).subscribe((data: any) => {
            this.expiryDate = "";
            this.effectiveDate = "";
            this.effectiveDate = "";
            this.fileeno = "";
            this.fileenoName = "";
            this.policyNumber = "";
            this.uploadExpEOPopup=false;
            this.finalDocs = data.data;
            this.loading = false;
            Swal.fire('', data.message, 'success');
            this.showExpiry = data.data.expiryDate;
            this.showDocumentName = data.data.documentName;
            this.showPolicyNumber = data.data.policyNumber;
            this.getLeadSDocumentAgency(this.agencyId,this.agencyIndex);
            this.uploaddocs()
      
            // this.fileId = data.data.id;
            // this.import();
          }, err => {
            //  this.dismiss();
          });
          }       
      }
      uploadvoidchequeArray=[];
      uploadlicenseArray=[];

      fileUrlForEno: any;
      docId: any;
      doctrimtoUrl: any;
      doctrimUrl: any;
      checkedDoc: any;
      checkDocdesc:any;
      docFileId: any;
      getDocument() {
        this.callMgaAPI=false
         //
        // this.user.getdocuments().pipe()
        this.user.getDocumentDetailsLeadEO(this.leadId).pipe()
          .subscribe(
            data => {
              this.uploadvoidchequeArray=[];
              this.getDocuments=[];
              this.getLicences=[];
              this.getVoidCheck=[];
              this.addEOFlagAgency=false;
              this.agencyCallEO = false;
              if(data.data.accountDetails.length!=0){
                this.transitNo = data.data.accountDetails[0]?.transitNumber;
                this.financialInstitutionNo = data.data.accountDetails[0]?.finacialInstitutionNumber;
                this.accountNo = data.data.accountDetails[0]?.accountNumber;
                this.confirmaccountNo = data.data.accountDetails[0]?.accountNumber;
                this.maskaccountNo = data.data.accountDetails[0]?.accountNumber;
                this.eyeIconShowAccountNumber = data.data.accountDetails[0]?.accountNumberPlain;
              }
              else{
                this.transitNo =null;
                this.financialInstitutionNo=null;
                this.accountNo=null;
                this.confirmaccountNo =null;
                this.maskaccountNo =null;
                this.eyeIconShowAccountNumber =null;
              }
              if(data.data.documents != null){
                this.getDocuments.push(data.data.documents);
                this.showExpiry = data.data.documents.expiryDate;
                this.showDocumentName = data.data.documents.documentName;
                this.showPolicyNumber = data.data.documents.policyNumber;
                this.finalDocs = data.data.documents;
                this.fileUrlForEno = data.data.documents.fileUrl;
                this.docId = data.data.documents.id
                this.docFileId = data.data.documents.fileId
                // this.transitNo = data.data.accountDetails[0]?.transitNumber;
                // this.financialInstitutionNo = data.data.accountDetails[0]?.finacialInstitutionNumber;
                // this.accountNo = data.data.accountDetails[0]?.accountNumber;
                // this.confirmaccountNo = data.data.accountDetails[0]?.accountNumber;
              }
              // if(data.data.licences != null){
              //   this.getLicences = data.data.licences;
              // }
              
              if(data.data.licences != null){
                this.getLicences = data.data.licences;
                // obj["urltreamlic"] = data.data.licences[i].fileDownloadUrl.split('.').pop();
    
                for(let i=0;i<this.provinceLicencesarray.length;i++)
                {
                  if(this.provinceLicencesarray[i].docType=="Resident Address")
                  {
                   this.residentLicense=this.provinceLicencesarray[i].provinces.provinceCode
                    this.residentLicense1=this.provinceLicencesarray[i].provinces.provinceName +'-'+this.provinceLicencesarray[i].provinces.provinceCode
                   
                    this.ResidentLicenseExpiryDate=this.DatePipe.transform(this.getLicences[i].expiryDate,'MM/dd/yyyy');
                    
                  }
                  else{
                    this.getLicences1.push(this.provinceLicencesarray[i]);
                  }
                }
                  if(this.getLicences1.length>0){
                  if(this.getLicences1[0].docType=="Non Resident Address" && this.primaryAddressProvince1==undefined){
                    this.primaryAddressProvince1=this.getLicences1[0].provinces.id
                    this.EOexpiryDate1=this.DatePipe.transform(this.getLicences1[0].expiryDate,'MM/dd/yyyy');
                      }
                    }
                      if(this.getLicences1.length>1){
                      if(this.getLicences1[1].docType=="Non Resident Address" && this.primaryAddressProvince2==undefined){
                        this.primaryAddressProvince2=this.getLicences1[1].provinces.id
                        this.EOexpiryDate2=this.DatePipe.transform(this.getLicences1[1].expiryDate,'MM/dd/yyyy');
                          }
                        }
                        if(this.getLicences1.length>2){
                          if(this.getLicences1[2].docType=="Non Resident Address" && this.primaryAddressProvince3==undefined){
                            this.primaryAddressProvince3=this.getLicences1[2].provinces.id
                            this.EOexpiryDate3=this.DatePipe.transform(this.getLicences1[2].expiryDate,'MM/dd/yyyy');
                              }
                            }
                            if(this.getLicences1.length>3){
                              if(this.getLicences1[3].docType=="Non Resident Address" && this.primaryAddressProvince4==undefined){
                                this.primaryAddressProvince4=this.getLicences1[3].provinces.id
                                this.EOexpiryDate4=this.DatePipe.transform(this.getLicences1[3].expiryDate,'MM/dd/yyyy');
                                  }
                                }
                                if(this.getLicences1.length>4){
                                  if(this.getLicences1[4].docType=="Non Resident Address" && this.primaryAddressProvince5==undefined){
                                    this.primaryAddressProvince5=this.getLicences1[4].provinces.id
                                    this.EOexpiryDate5=this.DatePipe.transform(this.getLicences1[4].expiryDate,'MM/dd/yyyy');
                                      }
                                    }
                                    if(this.getLicences1.length>5){
                                      if(this.getLicences1[5].docType=="Non Resident Address" && this.primaryAddressProvince6==undefined){
                                        this.primaryAddressProvince6=this.getLicences1[5].provinces.id
                                        this.EOexpiryDate6=this.DatePipe.transform(this.getLicences1[5].expiryDate,'MM/dd/yyyy');
                                          }
                                        }
                                        if(this.getLicences1.length>6){
                                          if(this.getLicences1[6].docType=="Non Resident Address" && this.primaryAddressProvince7==undefined){
                                            this.primaryAddressProvince7=this.getLicences1[6].provinces.id
                                            this.EOexpiryDate7=this.DatePipe.transform(this.getLicences1[6].expiryDate,'MM/dd/yyyy');
                                              }
                                            }
                                              if(this.getLicences1.length>7){
                                              if(this.getLicences1[7].docType=="Non Resident Address" && this.primaryAddressProvince8==undefined){
                                                this.primaryAddressProvince8=this.getLicences1[7].provinces.id
                                                this.EOexpiryDate8=this.DatePipe.transform(this.getLicences1[7].expiryDate,'MM/dd/yyyy');
                                                  }
                                                }
                                                if(this.getLicences1.length>8){
                                                  if(this.getLicences1[8].docType=="Non Resident Address" && this.primaryAddressProvince9==undefined){
                                                    this.primaryAddressProvince9=this.getLicences1[8].provinces.id
                                                    this.EOexpiryDate9=this.DatePipe.transform(this.getLicences1[8].expiryDate,'MM/dd/yyyy');
                                                      }
                                                    }
                                                    if(this.getLicences1.length>9){
                                                      if(this.getLicences1[9].docType=="Non Resident Address" && this.primaryAddressProvince10==undefined){
                                                        this.primaryAddressProvince10=this.getLicences1[9].provinces.id
                                                        this.EOexpiryDate10=this.DatePipe.transform(this.getLicences1[9].expiryDate,'MM/dd/yyyy');
                                                          }
                                                        }
                                                        if(this.getLicences1.length>10){
                                                          if(this.getLicences1[10].docType=="Non Resident Address" && this.primaryAddressProvince11==undefined){
                                                            this.primaryAddressProvince11=this.getLicences1[10].provinces.id
                                                            this.EOexpiryDate11=this.DatePipe.transform(this.getLicences1[10].expiryDate,'MM/dd/yyyy');
                                                              }
                                                            }
                                                            if(this.getLicences1.length>11){
                                                              if(this.getLicences1[11].docType=="Non Resident Address" && this.primaryAddressProvince12==undefined){
                                                                this.primaryAddressProvince12=this.getLicences1[11].provinces.id
                                                                this.EOexpiryDate12=this.DatePipe.transform(this.getLicences1[11].expiryDate,'MM/dd/yyyy');
                                                                  }
                                                                }
                
              }
              if(data.data.accountDetails != null){
                this.getVoidCheck = data.data.accountDetails;
                this.uploadvoidchequeArray.push(data.data.accountDetails)
              }
            
            }, error => {
              //  if(this.baseservice.handleError(error)){
              //handle Exception from Server 404,401
             
    
            }, () => { });
    
      }
      getLeadSDocumentAgency(id,index){
        //debugger
        this.agencyId=id
        this.agencyIndex=index
        this.callMgaAPI=false
        //
        this.user.getAgencydocuments(this.agencyId,this.leadId).pipe()
      .subscribe(
          data => {
            this.agencyCallEO = true;
              this.getDocuments=[];
              this.getLicences=[];
              this.getVoidCheck=[];
              this.uploadvoidchequeArray=[];
              if(data.data.accountDetails.length!=0){
                this.transitNo = data.data.accountDetails[0]?.transitNumber;
                this.financialInstitutionNo = data.data.accountDetails[0]?.finacialInstitutionNumber;
                this.accountNo = data.data.accountDetails[0]?.accountNumber;
                this.confirmaccountNo = data.data.accountDetails[0]?.accountNumber;
                this.maskaccountNo = data.data.accountDetails[0]?.accountNumber;
                this.eyeIconShowAccountNumber = data.data.accountDetails[0]?.accountNumberPlain;
              }
              else{
                this.transitNo =null;
                this.financialInstitutionNo=null;
                this.accountNo=null;
                this.confirmaccountNo =null;
                this.maskaccountNo =null;
                this.eyeIconShowAccountNumber =null;
              }
              if(data.data.documents != null){
                this.getDocuments.push(data.data.documents);
              }
              if(data.data.licences != null){
                this.getLicences = data.data.licences;
              }
              if(data.data.accountDetails != null){
                this.getVoidCheck = data.data.accountDetails;
                this.uploadvoidchequeArray.push(data.data.accountDetails)
              }
            },error=>{
                },()=>{});
         
      }
      documenturl: any="";
// Url: any="";

onSelected(name,id,des,url,fileId){
  
  
    this.user.getLeadSharedLink(fileId).pipe()
  .subscribe(
      data => {

       //(data.data)
       this.Url=data.data
   
      },error=>{
     
          if(error.status == 400 || error.status==417){
              this.error=error.error.data;
             
           }
           else{
             
             this.error="Something went wrong.";
           }
      
          },()=>{});
  

    this.selectedFileName = name;
    this.docId = id;
    this.description = des;
    this.documenturl = url;
    // this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(this.documenturl)
    setTimeout(() => 
{
  this.deleteModal = !this.deleteModal;
},
150);
   
}
closeiframe(){
  this.documenturl="";
  this.Url="";
}
//-----------------------------------------------------Documen sec start----------------------------------------
      uploaddocs() {
        this.showdocuments = true;
      }
      
      msg: any;
      msgfinal: any;
      uploadEno() {
        var flag = true
        var errormsg = [];
        this.expiryDate = this.DatePipe.transform(this.expiryDate, 'yyyy-MM-dd');
        this.effectiveDate = this.DatePipe.transform(this.effectiveDate, 'yyyy-MM-dd');
        if (!this.fileeno || this.fileeno.length <= 0 || this.showemailErrorMsg == true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Choose File') }
        if (!this.expiryDate || this.expiryDate.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter Expiry Date') }
        if (!this.effectiveDate || this.effectiveDate.length <= 0) { this.showdateErrorMsgEffectiveDate = true; flag = false; errormsg.push('Enter Effective Date') }
        if (!this.policyNumber || this.policyNumber.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter E&O Policy Number') }
        if (this.enoSizeCheck==true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Please upload the filesize less than 4MB') }

        if (flag == true) {
          if(this.callMgaAPI==false){
            this.FileUpload();
          }
          else{
            this.documentType="EO"
            this.FileUploadMGA();
          }
        }
        else {
         
          this.msg = errormsg.toString();
          this.msgfinal = this.msg.replaceAll(",", '<br />');
          Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
          // this.uploadExpEOPopup=false;
        }
      }

      onEoSelected() {
        // this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrlForEno)
        this.Url = this.fileUrlForEno;
      }

      error: any;
      removedocs() {
        this.showdocuments = false;
        this.user.deleteDoc(this.docId).pipe()
          .subscribe(
            data => {
              this.fileeno = ""
              this.showemailErrorMsg = false
              this.fileenoName = ""
              this.expiryDate = ""
              this.policyNumber = ""
              Swal.fire("", data.data)
              this.getDocument();
            }, error => {
    
              if (error.status == 400 || error.status == 417) {
                this.error = error.error.data;
              }
              else {
    
                this.error = "Something went wrong";
              }
    
            }, () => { });
      }
      
//-----------------------------------------------------------Licence Sec start-------------------------------------
  fileExtensionLic: any;
  fileExtensionErrorLic: boolean = false;
  fileExtensionMessageLic: any;

  fileenoNameLic: any;
  licfile: File=null;
  FileSelectLic(event, i) {
  
    this.licfile = event.target.files[0];
    if(this.licfile.size>4194304){
      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }
    
    if (event.target.files.length > 0) {
      this.FileDataListLic = event.target.files;
      this.fileenoNameLic = this.FileDataListLic[0].name;

      this.fileExtensionLic = this.fileenoNameLic.split('.').pop();
      if (this.isInArray(this.acceptedExtensions, this.fileExtensionLic)) {
        this.fileExtensionErrorLic = false;
        this.fileExtensionMessageLic = ""

        this.uploadlicenseArray[i].showemailErrorMsgone = this.fileExtensionErrorLic
        this.fileenoNameLic = this.FileDataListLic[0].name;
      } else {
        this.fileExtensionMessageLic = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
        this.fileExtensionErrorLic = true;
        this.uploadlicenseArray[i].showemailErrorMsgone = this.fileExtensionErrorLic
        this.fileenoNameLic = this.fileExtensionMessageLic

      }
      //this.uploadlicenseArray[i].showemailErrorMsgone=this.fileExtensionError;
      //this.fileenoNameLic=this.fileExtensionMessage;
    } else {
      this.uploadlicenseArray[i].showemailErrorMsgone = false;
      this.fileenoNameLic = ""
    }
  }
  FileUploadLic(uploadlic, k) {
    this.oricid=uploadlic.oricDocumentId
    if(this.FileDataListLic!=undefined){
    for (var i = 0; i < this.FileDataListLic.length; i++) {
      this.productPhotofile = this.FileDataListLic[i];
      if (this.productPhotofile != null) {
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', uploadlic.expiryDate);
        formData.append('effectiveDate', uploadlic.effectiveDate);
        var data = this.leadId

        formData.append('leadId', data);
        formData.append('licencesNumber', uploadlic.licenseNumber);
        // formData.append('lincencesName', uploadlic.licenseName);
        formData.append('lincencesName', uploadlic.lincencesName);
        formData.append('licencesType', uploadlic.licencesType);
        formData.append('province', uploadlic.province);
        if(this.fileIdlic!=null){
        formData.append('fileId', this.fileIdlic);
      }
      if(this.licenceId!=null){
        formData.append('licenceId', this.licenceId);
      }
        // this.fileData=formData
        if(this.checkAddlicFlagAgency ==true){
          formData.append('agencyId', this.agencyId);
        }
        if(this.oricid!==null && this.oricid!=="" && (this.oricid!==undefined && this.oricid!=="undefined")){
          formData.append('oricDocumentId', this.oricid);
        }
        this.uploadImagesLic(formData, k)
      }
    }
    }else{
      const formData = new FormData();
      // formData.append('file', this.productPhotofile);
      formData.append('expiryDate', uploadlic.expiryDate);
      formData.append('effectiveDate', uploadlic.effectiveDate);
      var data = this.leadId

      formData.append('leadId', data);
      formData.append('licencesNumber', uploadlic.licenseNumber);
      
      // formData.append('lincencesName', uploadlic.lincencesName);
      formData.append('licencesType', uploadlic.licencesType);
      formData.append('province', uploadlic.province);
      if(this.fileIdlic!=null || this.licenceId!=null){
      formData.append('fileId', this.fileIdlic);
      formData.append('licenceId', this.licenceId);
    }
      // this.fileData=formData
      if(this.checkEditlicFlagAgency ==true){
        formData.append('agencyId', this.agencyId);
      }
      if(this.oricid!==null && this.oricid!=="" && (this.oricid!==undefined && this.oricid!=="undefined")){
        formData.append('oricDocumentId', this.oricid);
      }
      this.uploadImagesLic(formData, k)
    }
  }

  async uploadImagesLic(formData: FormData, k) {
    if(this.checkAddlicFlag==true){
      if(this.checkAddlicFlagAgency==false){
      this.user.submitFormService(this.config.uploadLicensOA, formData).subscribe((data: any) => {
        this.loading = false;
        Swal.fire('', data.message, 'success');
        this.getDocument();
        this.uploadnewLicensePopup=false
        //  this.showlicense=true;
        this.fileenoNameLic = "";
        this.uploadlicenseArray.splice(k, 1);
        this.uploadlicenseArray.push(data.data)
      }, err => {
  
      });
    }else{
      this.user.submitFormService(this.config.uploadLicensOACompany, formData).subscribe((data: any) => {
        this.loading = false;
        Swal.fire('', data.message, 'success');
        this.getLeadSDocumentAgency(this.agencyId,this.agencyIndex);
        this.uploadnewLicensePopup=false
        //  this.showlicense=true;
        this.fileenoNameLic = "";
        this.uploadlicenseArray.splice(k, 1);
        this.uploadlicenseArray.push(data.data)
      }, err => {
  
      });
    }
    }else{
      if(this.checkEditlicFlagAgency ==false){
      this.loading = true;
      this.user.submitFormService(this.config.OverWriteLicences, formData).subscribe((data: any) => {
        this.loading = false;
        Swal.fire('', data.message, 'success');
        this.getDocument();
        // this.showlicense=true;
        this.fileenoNameLic = "";
        this.uploadlicenseArray.splice(k, 1);
        this.uploadlicenseArray.push(data.data)
        this.uploadnewLicensePopup=false;
      }, err => {
  
      }); 
    }else{
      this.loading = true;
      this.user.submitFormService(this.config.updateLicenes, formData).subscribe((data: any) => {
        this.loading = false;
        Swal.fire('', data.message, 'success');
        this.getLeadSDocumentAgency(this.agencyId,this.agencyIndex);
        // this.showlicense=true;

        this.fileenoNameLic = "";
        this.uploadlicenseArray.splice(k, 1);
        this.uploadlicenseArray.push(data.data)
        this.uploadnewLicensePopup=false;
      }, err => {
  
      }); 
    }
    }
  }


  uploadlicensefile(uploadlic, i) {
    if(this.callMgaAPI==false){
    var flag = true
    var errormsg = [];
      
    uploadlic.expiryDate = this.DatePipe.transform(uploadlic.expiryDate, 'yyyy-MM-dd');
    uploadlic.effectiveDate = this.DatePipe.transform(uploadlic.effectiveDate, 'yyyy-MM-dd');
   // if(this.fileIdlic==null){
      if (!uploadlic.filelicens || uploadlic.filelicens.length <= 0 || uploadlic.showemailErrorMsgone == true) { uploadlic.showemailErrorMsgone = true; flag = false; errormsg.push('Choose File') }
   // }
    if (!uploadlic.licenseNumber || uploadlic.licenseNumber.length <= 0) { uploadlic.showlicnErrorMsgone = true; flag = false; errormsg.push('Enter License Number') }
    if(!uploadlic.licencesType || uploadlic.licencesType.length <= 0){uploadlic.showlictErrorMsgone = true;  flag=false; errormsg.push('License Type')} 
    if (!uploadlic.expiryDate || uploadlic.expiryDate.length <= 0) { uploadlic.showlicdErrorMsgone = true; flag = false; errormsg.push('Enter Expiry Date') }
    if (!uploadlic.effectiveDate || uploadlic.effectiveDate.length <= 0) { uploadlic.showEffectiveDateErrorMsgone = true; flag = false; errormsg.push('Enter Effective Date') }
    if (!uploadlic.province || uploadlic.province.length <= 0) { uploadlic.showlicpErrorMsgone = true; flag = false; errormsg.push('Select Province') }
    // if(!uploadlic.licenseName || uploadlic.licenseName.length <= 0){uploadlic.showlicnameErrorMsgone=true;  flag=false; errormsg.push('Provience')} 

    if (flag == true) {
      this.FileUploadLic(uploadlic, i);
    }
    else {
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replaceAll(",", '<br />');
      Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
    }
  }else{
    this.uploadlicensefileMGA(uploadlic, i)
  }
  }

  licensPreview: any;
  onPreviewLicens(url) {
    this.licensPreview = url;
    // this.licensPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url)

  }


  addFieldValue() {
    this.uploadlicenseArray.push(this.newAttribute)
    this.newAttribute = {};
  }

  deleteFieldValue(index) {
   
    this.uploadlicenseArray.splice(index, 1);
  }

  showlicense: boolean = false;
  removelicense(i, id) {
    this.showlicense = false;
    this.user.deleteLicens(id).pipe()
      .subscribe(
        data => {
          if (data.success == true) {
            Swal.fire("", data.data);
            //this.uploadlicenseArray.splice(i, 1);
            this.getDocument();
          if (this.uploadlicenseArray.length == 0) {
                  this.uploadlicenseArray.push(this.newAttribute)
                  this.newAttribute = {};
                }
          }
        }, error => {

          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;
          }
          else {

            this.error = "Something went wrong";
          }

        }, () => { });
  }

//-----------------------------------------void check start--------------------------------------------
newAttributenext: any = {}
addFieldValuecheque() {
  this.uploadvoidchequeArray.push(this.newAttributenext)
  this.newAttributenext = {};
  //this.uploaddocs2();
}

fileExtensionVC: any;
fileExtensionErrorVC: boolean = false;
fileExtensionMessageVC: any;
FileDataList1: any;
fileenoName1: any;
voidfile: File= null;
voidSizeCheck:boolean=false;
FileSelect1(event, i) {
  if (event.target.files.length > 0) {
  this.voidfile = event.target.files[0];
    if(this.voidfile.size>4194304){
      this.voidSizeCheck=true;
      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }else{
      this.showemailErrorMsg1 = false;
      this.voidSizeCheck=false;
    }

 
    this.FileDataList1 = event.target.files;
    this.fileenoName1 = this.FileDataList1[0].name;

    this.fileExtensionVC = this.fileenoName1.split('.').pop();
    if (this.isInArray(this.acceptedExtensions, this.fileExtensionVC)) {
      this.fileExtensionErrorVC = false;
      this.fileExtensionMessageVC = ""

      this.uploadvoidchequeArray[i].showemailErrorMsg1 = this.fileExtensionErrorVC
      this.fileenoName1 = this.FileDataList1[0].name;
    } else {
      this.fileExtensionMessageVC = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
      this.fileExtensionErrorVC = true;
      this.uploadvoidchequeArray[i].showemailErrorMsg1 = this.fileExtensionErrorVC
      this.fileenoName1 = this.fileExtensionMessageVC

    }

  } else {
    // this.uploadvoidchequeArray[i].showemailErrorMsg1 = false;
    this.uploadvoidchequeArray[i].fileeno1=this.fileenoName1
    // this.fileenoName1 = ""
  }
}

showemailErrorMsg1: boolean = false;
uploadEno1(item, i) {
  //
  // if(this.leadStatusStage=="Activated"){
    item.fileId=null
  // }
  var flag = true
  var errormsg = [];
  try{this.transitNo=this.transitNo.trim()}catch{}
  try{this.financialInstitutionNo=this.financialInstitutionNo.trim()}catch{}
  try{this.accountNo=this.accountNo.trim()}catch{}
  try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
  // if(this.allowUser == true){
  //   if (this.btnPopupName == "Confirm"){
  //     if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;}
  //     if ( !this.transitNo || this.transitNo.length <= 0) { this.transitNoErrMsg=true;flag = false;}
  //     if ( !this.financialInstitutionNo || this.financialInstitutionNo.length <= 0) { this.financialInstitutionNoErrMsg=true;flag = false;}
  //     if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false;}
  //   }else {
  //     if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
  //   }
  // } else{
  //   this.bankInfoErrmsg = true;
  //   flag = false;
  // }
//  if(this.allowUser == true){
//   if (this.btnPopupName == "Save"){
//     if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;}
//     if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;}
//     if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false;}
//     if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false;}
//     // if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
//     if(item.fileId!==undefined && item.fileId!==null){
//       if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
//     }else{
//       if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
//     }
//   }
//  }else {
//   this.bankInfoErrmsg = true;
//     flag = false;
//  }

 
  if (this.btnPopupName == "Save"){
    if(this.accountNo!==this.confirmaccountNo){flag = false; errormsg.push('Account Number and Confirm Account Number does not match.');}
      if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number.')}
      if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number.')}
      if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number.')}
      if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false; errormsg.push('Enter valid Confirm Account Number.')}
      if ( this.allowUser == false) { this.bankInfoErrmsg = true;flag = false;;  errormsg.push('Please click the acknowledgement checkbox.')}
     
    if(item.fileId!==undefined && item.fileId!==null){
      if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
    }else{
      if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
    }
  // }else{
  //   flag=false;
  //   if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number.')}
  //   if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number.')}
  //   if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number.')}
  //   if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false; errormsg.push('Enter valid Confirm Account Number.')}
  //   if ( !this.bankinfoChecked ) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
  //   errormsg.push('Account Number and Confirm Account Number does not match.');
  // }
  if(this.bankinfoChecked==true){
    this.bankInfoErrmsg=false
  }else{
    this.bankInfoErrmsg=true;
    flag = false;
  }
  
  }else{
    if (this.btnPopupName == "Confirm"){
      
      if(this.accountNo!==this.confirmaccountNo){flag = false; errormsg.push('Account Number and Confirm Account Number does not match.');}
        if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number.')}
        if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number.')}
        if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number.')}
        if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false; errormsg.push('Enter valid Confirm Account Number.')}
        if ( this.allowUser == false) { this.bankInfoErrmsg = true;flag = false;;  errormsg.push('Please click the acknowledgement checkbox.')}
      // if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
      if(item.fileId!==undefined && item.fileId!==null){
        if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
      }else{
        if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
      }
    // }
    // else{
    //   flag=false;
    //   if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number.')}
    //   if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number.')}
    //   if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number.')}
    //   if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false; errormsg.push('Enter valid Confirm Account Number.')}
    //   if ( this.allowUser == false) { this.bankInfoErrmsg = true;flag = false;;  errormsg.push('Please click the acknowledgement checkbox.')}
    //   errormsg.push('Account Number and Confirm Account Number does not match.');
    // }
    // if(this.bankinfoChecked==true){
    //   this.bankInfoErrmsg=false
    // }else{
    //   this.bankInfoErrmsg=true;
    //   flag = false;
    // }
    
    }
  
  }

 
  if ( this.voidSizeCheck==true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Please upload the filesize less than 4MB')} 

  if (flag == true) {

    
    if(this.callMgaAPI==false){
      this.FileUpload1(item, i);
    }else{
      this.documentType="VOID_CHEQUE"
    this.FileUploadVoidMGA(item, i);
    }
  }
  else {
      if(this.bankinfoChecked==true){
    this.bankInfoErrmsg=false
    }else{
      this.bankInfoErrmsg=true;
      flag = false;
    }
    // this.confirmAccountNumberMatch = true;
    // if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false; errormsg.push('Enter valid Confirm Account Number')}
    // if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number')}
    // if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number')}
    // if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number')}
    // if ( !this.bankinfoChecked) { this.bankInfoErrmsg=true;flag = false; errormsg.push('To continue,read the above Information. If you agree, check the box beside.')}
    this.msg = errormsg.toString();
    // this.msgfinal = this.msg.replace(",", '<br />');
    this.msgfinal = this.msg.replaceAll(",", '<br />');
    Swal.fire("", "Please complete the following mandatory field(s):"+"<br>" + this.msgfinal, 'warning')

  }

}
productPhotofile1: any;
  FileUpload1(item, k) {
    //
    if(this.allowUser == true){
      if(this.btnPopupName == "Save"){
        for (var i = 0; i < this.FileDataList1.length; i++) {
          this.productPhotofile1 = this.FileDataList1[i];
          if (this.productPhotofile1 != null) {
            const formData = new FormData();
            formData.append('accountNumber', this.accountNo);
            formData.append('confirmaccountNo', this.confirmaccountNo);
            formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
            formData.append('transitNumber', this.transitNo);
            formData.append('file', this.productPhotofile1);
            var data =  this.leadId
            formData.append('leadId', data);
            if (this.fileIdvoid != null || this.voidchequeId != null) {
              formData.append('fileId', this.fileIdvoid);
              formData.append('voidChequeId', this.voidchequeId);
            }
            if (this.agencyCallEO == true) {
              formData.append('agencyId ', this.agencyId);
            }
            this.uploadImages1(formData, k)
          }

        }
      }
      if(this.btnPopupName == "Confirm"){
        // for (var i = 0; i < this.FileDataList1.length; i++) {
          if(this.FileDataList1!=undefined){
           this.productPhotofile1 = this.FileDataList1[0];
          }
          // if (this.productPhotofile1 != null) {
            const formData = new FormData();
            formData.append('accountNumber', this.accountNo);
            formData.append('confirmaccountNo', this.confirmaccountNo);
            formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
            formData.append('transitNumber', this.transitNo);
            if(this.productPhotofile1!=undefined){
              formData.append('file', this.productPhotofile1);
            }
            
            var data =  this.leadId
            formData.append('leadId', data);
            if (this.fileIdvoid != null || this.voidchequeId != null) {
              formData.append('fileId', this.fileIdvoid);
              formData.append('voidChequeId', this.voidchequeId);
            }
            if (this.agencyCallEO == true) {
              formData.append('agencyId ', this.agencyId);
            }
            this.uploadImages1(formData, k)
          // }

        // }
      }
    }else{
        if(this.FileDataList1!=undefined){
          for (var i = 0; i < this.FileDataList1.length; i++) {
            this.productPhotofile1 = this.FileDataList1[i];
            if (this.productPhotofile1 != null) {
              const formData = new FormData();
              formData.append('accountNumber', this.accountNo);
              formData.append('confirmaccountNo', this.confirmaccountNo);
              formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
              formData.append('transitNumber', this.transitNo);
              formData.append('file', this.productPhotofile1);
              var data =  this.leadId
              formData.append('leadId', data);
              if (this.fileIdvoid != null || this.voidchequeId != null) {
                formData.append('fileId', this.fileIdvoid);
                formData.append('voidChequeId', this.voidchequeId);
              }
              if (this.agencyCallEO == true) {
                formData.append('agencyId ', this.agencyId);
              }
              this.uploadImages1(formData, k)
            }
  
          }
      }
    }
  }

finalDocs1: any;
showDocumentName1: any;
async uploadImages1(formData: FormData, k) {
  
  this.loading = true;
  
  if(this.agencyCallEO == false){
  if(this.voidchequeId==null){
  this.user.submitFormService(this.config.uploadVoidChequebroker, formData).subscribe((data: any) => {

    this.finalDocs1 = data.data;
    this.loading = false;
    this.BankInfo=false;
    this.uploadVoidChequePopup = false;
    Swal.fire('', data.message, 'success');
    this.getDocument();
    this.openTabs2(0)
    this.showDocumentName1 = data.data.documentName;
    this.fileenoName1 = ""
    this.uploadvoidchequeArray.splice(k, 1);
    this.uploadvoidchequeArray.push(data.data)

  }, err => {

  });
}
else{
  this.user.submitFormService(this.config.OverWriteVoidCheque, formData).subscribe((data: any) => {
    this.fileIdvoid=null; 
    this.voidchequeId=null;
    this.finalDocs1 = data.data;
    this.loading = false;
    this.BankInfo=false;
    this.uploadVoidChequePopup = false;
    Swal.fire('', data.message, 'success');
    this.getDocument();
    this.openTabs2(0)
    this.showDocumentName1 = data.data.documentName;
    this.fileenoName1 = ""
    this.uploadvoidchequeArray.splice(k, 1);
    this.uploadvoidchequeArray.push(data.data)

  }, err => {

  });
}
  }
  else{
    if(this.voidchequeId==null){
      this.user.submitFormService(this.config.uploadVoidChequeOAAgency, formData).subscribe((data: any) => {
    
        this.finalDocs1 = data.data;
        this.loading = false;
        this.BankInfo = false;
        this.uploadVoidChequePopup = false;
        Swal.fire('', data.message, 'success');
        this.getLeadSDocumentAgency(this.agencyId,this.agencyIndex);
        this.openTabs22(this.agencyIndex)
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)
    
      }, err => {
    
      });
    }
    else{
      this.user.submitFormService(this.config.overriteVoidAgency, formData).subscribe((data: any) => {
        this.fileIdvoid=null; 
        this.voidchequeId=null;
        this.finalDocs1 = data.data;
        this.loading = false;
        this.BankInfo=false;
        this.uploadVoidChequePopup = false;
        Swal.fire('', data.message, 'success');
        this.getLeadSDocumentAgency(this.agencyId,this.agencyIndex);
        this.openTabs22(this.agencyIndex)
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)
    
      }, err => {
    
      });
    }
  }
}

showdocuments1: boolean = false;
uploaddocs1() {
  this.showdocuments1 = true;
}

removedocs1(i, id) {
  // console.log(id)
  this.user.deleteVoidCheck(id).pipe()
    .subscribe(
      data => {
        if (data.success == true) {
          Swal.fire("", data.data);
          this.getDocument();
          if (this.uploadvoidchequeArray.length == 0) {
            this.uploadvoidchequeArray.push(this.newAttributenext)
            this.newAttributenext = {};
          }
          // this.uploadvoidchequeArray.splice(i, 1);
        }
      }, error => {

        if (error.status == 400 || error.status == 417) {
          this.error = error.error.data;
        }
        else {

          this.error = "Something went wrong";
        }

      }, () => { });

}
removeVoid(i) {
  this.uploadvoidchequeArray.splice(i, 1);
}

voidPreview: any;
onvoidPreview(url) {
  // this.voidPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url)
  this.voidPreview = url;
}
//----------------------------------------------void check end------------------------------------------------

contractDetails=[]
getLeadContractSign(){
  var data = sessionStorage.getItem('selectedMgaId')
  this.user.getContractInfo(data).pipe()
.subscribe(
    data => {
      if(data.data != "No contract Found"){
        this.contractDetails=[];
        // this.contractDetails.push(data.data);
        for(let i=0; i<data.data.length;i++){
           this.contractDetails.push(data.data[i]);
        }
      }
    },error=>{
        },()=>{});
}
//----------------------------------------------void check end------------------------------------------------
signAggrement: any;
onSignAggrement(url) {
  // this.voidPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url)
  this.signAggrement = url;
}
ngOnDestroy(){
  sessionStorage.removeItem('leadPage');
}

nextClickHide:boolean=false
nextClickLeads(id){
  
for(let i=0;i<this.allMgaData.length;i++){
  if(id == this.allMgaData[i].id){
    i++;
    sessionStorage.setItem('selectedMgaId',this.allMgaData[i].id);
  }
  else if(id == this.allMgaData[i]?.lead?.id){
    i++;
    sessionStorage.setItem('selectedMgaId',this.allMgaData[i]?.lead?.id);
  }
   

}
location.reload();
}
previousClick: boolean=false;
previousClickLeads(id){
  
  for(let i=0;i<this.allMgaData.length;i++){
    if(id == this.allMgaData[i].id){
     var back = i-1;
      sessionStorage.setItem('selectedMgaId',this.allMgaData[back].id);

    }
    else if(id == this.allMgaData[i]?.lead?.id){
      var back = i-1;
      sessionStorage.setItem('selectedMgaId',this.allMgaData[back]?.lead?.id);
    }
      
}
location.reload();
}

stageWisePercentage = [];
  brokerType: any;
  commitionType: any;
  fromDate: any;
  fromDateTest: any;
  stageStatus=[];
  stageStatusTest=[];
  assignedUsersTest=[];
  assignedUsersTestStatus=[];
  toDate: any;
  commitionTypeArray=[];
  leadTypesArray=[];
  stagesArray=[];
  commitionTypeTest=[];
  brokerTypeTest=[];
  everSigntemplatesArray: any=[];
  sendContractShow: boolean = false;
  refreshToken: any;
  showeverSign: boolean = false;
  selectedItem: any;
  keys: any;
  posteverSign: boolean;
  brokerType1=[];
  commitionType1=[];
  agencyMgaIds=[];
  MGAfilter: any;
  MGAfilterTypeTest=[];
test(a,a1){
     
  (a);
this.stageStatus=[];
localStorage.setItem('filterStatus', a);
localStorage.setItem('filterStatusIndex', a1);
this.stageStatus.push(a);

if(this.fromDateTest != null || undefined){
this.fromDate=this.fromDateTest[0]
this.fromDate = this.DatePipe.transform(this.fromDate, 'yyyy-MM-dd');

this.toDate=this.fromDateTest[1]
this.toDate = this.DatePipe.transform( this.toDate, 'yyyy-MM-dd');
}
else{
this.fromDate=null;
this.toDate=null;
}

if(this.brokerType == "Select"|| this.brokerType== undefined){
this.brokerType1=this.brokerTypeTest

}
else{
this.brokerType1.push(this.brokerType);
}
if(this.commitionType ==  "Select" || this.commitionType== undefined){
this.commitionType1=this.commitionTypeTest

}
else{
this.commitionType1.push(this.commitionType);
}

this.user.filterLeadsPost(this.brokerType1,this.commitionType1,this.fromDate,this.stageStatus,this.toDate,this.mgaId)
.pipe()
.subscribe(
    data => {
       
      if(data.status== true){
        // Swal.fire('',data.message,'success')
        }
        if(data.status== false){
          Swal.fire('',data.message,'error')
          }
        // if(data.data.leads.length != 0){
        //   this.leads=[];
        //   for(let i=0; i<data.data.leads.length;i++){
        //     this.leads.push(data.data.leads[i]);
        //     this.total = data.data.total;
        //     this.showLead=data.data.total;
     
        //   }
        // }
        // if(data.data.stageWisePercentage.length != 0){
        //   this.stage=[];
        //   for(let i=0; i<data.data.stageWisePercentage.length;i++){
        //     this.stage.push(data.data.stageWisePercentage[i]);
        //    // this.total = data.data.totalPages
        //   }
        // }
      
    },error=>{
      if(error=="Bad Request"){
        Swal.fire("Bad Request please try again!")
       
     }
     else{
      Swal.fire("Something went wrong. Please check and try again!")
     
     
     }
        },()=>{});
}
getMisc:[];
pdfmodelMisc:boolean=false;
UrlMisc:any
miscPreview:any;
selectedFileName:any
getMiscDocument(){
  this.user.getMiscDocument(this.leadId).pipe()
.subscribe(
    data => {
        this.getMisc = data.data;
    },error=>{
        },()=>{});
}
onPreviewMisc(url,fileIdMisc) {
  // this.licensPreview = url;
  this.user.getLeadPreviewLink(fileIdMisc).pipe()
  .subscribe(
      data => {
          
       this.UrlMisc=data.data
   
      },error=>{
     
          if(error.status == 400 || error.status==417){
              this.error=error.error.data;
             
           }
           else{
             
             this.error="Something went wrong.";
           }
      
          },()=>{});
          this.selectedFileName = name;
    //this.docId = id;
  setTimeout(() => 
  {
    this.pdfmodelMisc = !this.pdfmodelMisc;
  },
  2500);
  // this.licensPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url)

}
uploadnewLicensePopup:boolean=false;
uploadExpEOPopup:boolean=false;
minDate = new Date();
onClickaddnewLicUpload(){
  this.uploadnewLicensePopup=false;
    Swal.fire("", "License successfully summited", 'success')
  }

fileExtensionErrorMsg: boolean=false;
showlicdErrorMsgone:  boolean=false;
showlicnErrorMsgone:  boolean=false;
showEffectiveDateErrorMsgone:  boolean=false;
province: any;
licenseNumber: any;
filelicens: any;
expiryDateLic1: any;
fileIdlic:any;
licenceId:any;
doumentId:any;
OverwriteEODoc(val){
  
  this.addEOFlag=false;
  this.fileenoName=val.documentName
  this.fileeno=val.fileId 
  this.policyNumber=val.policyNumber
 this.expiryDate=val.expiryDate
 this.effectiveDate=val.effectiveDate
  this.doumentId=val.id
}
addEOFlagAgency:boolean=false;
agencyCallEO:boolean=true;
OverwriteEODocAgency(val){
  
  this.addEOFlagAgency=false;
  this.agencyCallEO = true;
  this.fileenoName=val.documentName
  this.fileeno=val.fileId 
  this.policyNumber=val.policyNumber
 this.expiryDate=val.expiryDate
  this.doumentId=val.id
  this.isOverWriteEO=true
  this.effectiveDate=val.effectiveDate
}
OverwriteLic(licval,index){
      
  var obj={
    "expiryDate":licval.expiryDate,
    "effectiveDate":licval.effectiveDate,
 "province":licval.licencesProvince,
 "licencesType":licval.type,
 "licenseNumber":licval.licensesNumber,
 "filelicens":licval.fileId,
 "lincencesName":licval.licenseName,
 "oricDocumentId":licval.oricDocumentId
  }
 this.uploadlicenseArray=[]
 this.uploadlicenseArray.push(obj)
 this.fileIdlic=licval.fileId
 this.fileenoNameLic=licval.licenseName,
 this.licenceId=licval.id;
 this.checkAddlicFlag=false;
 this.checkEditlicFlagAgency=false
 // this.uploadLicensePopup = !this.uploadLicensePopup
 
 }
 checkEditlicFlagAgency: boolean=false;
 OverwriteLicAgency(licval,index){
      
  var obj={
 "expiryDate":licval.expiryDate,
 "effectiveDate":licval.effectiveDate,
 "province":licval.licencesProvince,
 "licencesType":licval.type,
 "licenseNumber":licval.licensesNumber,
 "filelicens":licval.fileId,
 "lincencesName":licval.licenseName,
 "oricDocumentId":licval.oricDocumentId
  }
 this.uploadlicenseArray=[]
 this.uploadlicenseArray.push(obj)
 this.fileIdlic=licval.fileId
 this.fileenoNameLic=licval.licenseName,
 this.licenceId=licval.id;
 this.checkAddlicFlag=false;
 this.checkAddlicFlagAgency=false
 this.checkEditlicFlagAgency=true
 // this.uploadLicensePopup = !this.uploadLicensePopup
 this.isOverWriteEO=true
 }
 addcompanyLic(){
   this.fileIdlic=null,
 this.fileenoNameLic=null,
 this.licenceId=null
 }
 uploadAddnewLicensePopup:boolean=false;
 checkAddlicFlag:boolean=false
 openAddLicPopup(){
  var obj={
    "expiryDateLic1":'',
    "province":null,
    "licencesType":null,
    "licenseNumber":'',
    "filelicens":'',
    "lincencesName":'',
    "effectiveDate":''
     }
    this.uploadlicenseArray=[]
    this.uploadlicenseArray.push(obj)
    this.checkAddlicFlag=true
    this.checkAddlicFlagAgency=false;
    this.fileenoNameLic="";
    this.isOverWriteEO=false
 }
 checkAddlicFlagAgency:boolean=false;
 openAddLicPopupAgency(){
  var obj={
    "expiryDateLic1":'',
    "province":null,
    "licencesType":null,
    "licenseNumber":'',
    "filelicens":'',
    "lincencesName":'',
    "effectiveDate":''
     }
    this.uploadlicenseArray=[]
    this.uploadlicenseArray.push(obj)
    // this.checkAddlicFlag=false
    this.checkAddlicFlagAgency=true;
    this.checkAddlicFlag=true
    this.fileenoNameLic="";
    this.isOverWriteEO=false
 }
 addEOFlag: boolean=false;
 addEoStatus(){
   this.addEOFlag=true;
   this.fileenoName=""
  this.fileeno=""
  this.policyNumber=""
  this.expiryDate=""
  this.doumentId=""
 }
 addEoStatusAgency(){
  this.addEOFlag=false;
  this.addEOFlagAgency=true;
  this.agencyCallEO = true;
  this.fileenoName=""
 this.fileeno=""
 this.policyNumber=""
 this.expiryDate=""
 this.doumentId=""
}
uploadVoidChequePopup:boolean=false;
fileIdvoid:any;
voidchequeId:any;
overwriteVoid(voidval){
this.fileIdvoid=voidval.fileId;
this.voidchequeId=voidval.id;
this.isOverWriteEO=true
var obj={
  "fileeno1":voidval.fileUrl,
   }
  this.uploadvoidchequeArray=[]
  this.uploadvoidchequeArray.push(voidval)
   this.fileenoName1=voidval.documentName
}
passwordAgenctCode:any;
agencyCodeAgent:any;
userId:any;
getDataOfUnderwriterLeadAgentCode(){
  this.user.getUnderwritersLeadAgentCodes(this.leadId).pipe()
.subscribe(
    data => {
      for(let i=0; i<data.data.agentCodes.length; i++){
        if(data.data.agentCodes[i].status=="Primary"){
          this.userId=data.data.agentCodes[i].agentUserId;
          this.agencyCodeAgent=data.data.agentCodes[i].agentCode;
          this.passwordAgenctCode=data.data.agentCodes[i].password;
        }
      }    
      this.blockUI.stop();
      
      this.showAgentCodeCount = data.data.agentCodeCount
      if(this.showAgentCodeCount != 0){
      this.showAgentCodeButton=true;
      }
      this.getAgentCodeDetails=[];
      for(let i=0; i<data.data.agentCodes.length; i++){
        if(data.data.agentCodes.length>0){
          if(data.data.agentCodes[i].status=="Primary"){
          this.primaryAgentCodeShow=data.data.agentCodes[i].agentCode
          }
        }
        if(data.data.agentCodes[i].status=="Primary" || data.data.agentCodes[i].status=="Active"){
          this.getAgentCodeDetails.push(data.data.agentCodes[i]);
        }
      }

      if(!this.primaryAgentCodeShow){
        for(let i=0; i<data.data.agentCodes.length; i++){
          if(this.getAgentCodeDetails.length>0){
        if(this.getAgentCodeDetails[i].status=="Active"){
        this.primaryAgentCodeShow=this.getAgentCodeDetails[i].agentCode
        }
      }
      }
    }
    
    if(!this.primaryAgentCodeShow){
      this.showDropDown1=false;
    }        
    },error=>{
        },()=>{});
}
  otpVerificationPopup:boolean=false;
  otpOfVoidCheque:any;
  documentIdForOTPVerificationData:any=null;

  onClickOTPValidation(item){
    if(this.leadStatusStage == 'Activated'){
      this.otpOfVoidCheque=null;
      this.documentIdForOTPVerificationData=item;
      const request = {
        "documentId": this.documentIdForOTPVerificationData?.id,
        "otp": ""
      }    
      this.base.callPostService(this.config.checkAlreadyAuthoriseForVoidCheque, request).subscribe((data:any) =>{
        if(data.status==true){
          this.onSelected(this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.id,this.documentIdForOTPVerificationData?.description,this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.fileId)
        }else{
          this.otpVerificationPopup=true;
          this.sendOtpForVoidCheque();
        }
      },error=>{{
      }},()=>{});
    }else{
      
    }
    
  }
  sendOtpForVoidCheque(){
    const request = {
      "documentId": this.documentIdForOTPVerificationData?.id,
      "otp": ""
    }    
    this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
      if(data.status==true){
        this.startOtpTimer()
        this.toastr.success("Verification Code sent successfully.");
      }else{
        this.toastr.error(data.message);
      }
    },error=>{{
    }},()=>{});
  }
  verifyOTP(){
    const request = {
      "documentId": this.documentIdForOTPVerificationData?.id,
      "otp": this.otpOfVoidCheque
    }    
    this.base.callPostService(this.config.verifyOtpForVoidCheque, request).subscribe((data:any) =>{
    if(data.status==true){
        this.otpVerificationPopup=false;
        this.onSelected(this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.id,this.documentIdForOTPVerificationData?.description,this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.fileId)
      }else{
        this.toastr.error("Incorrect Verification Code");
      }
    },error=>{{
    }},()=>{});
  }
  resendVoidChequeOTP(){
    this.otpOfVoidCheque=null;
    this.otpVerificationPopup=true;
    const request = {
      "documentId": this.documentIdForOTPVerificationData?.id,
      "otp": ""
    }    
    this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
      if(data.status==true){
        this.startOtpTimer()
        this.toastr.success("Verification Code sent successfully.");
      }else{
        this.toastr.error(data.message);
      }
    },error=>{{
    }},()=>{});
  }
voidIndexitem: any;
indexno: any;
uploadEno1Void(item,i){
  //
  if(this.leadStatusStage=="Activated"){
    
    this.voidIndexitem=[]
  }
  else{
    this.voidIndexitem=item;
  }
 
  this.indexno=i;
}
// uploadEno1Void(voidval,i){
//   this.voidIndexitem=voidval;
//   this.indexno=i;
//   this.fileIdvoid=voidval.fileId;
//   this.voidchequeId=voidval.id;

// }
// uploadEno1Void(voidval,i){
//   this.voidIndexitem=voidval;
//   this.indexno=i;
//   this.fileIdvoid=voidval.fileId;
//   this.voidchequeId=voidval.id;
// // 
//    var obj={
  
//   "fileeno1":voidval.fileUrl,
//    }
//   this.uploadvoidchequeArray=[]
//   this.uploadvoidchequeArray.push(obj)
//    this.fileenoName1=voidval.documentName
//    this.btnPopupName="Confirm";
// }
// editBankInfo(){
//   this.popupName="Update"
//   this.btnPopupName ="Save"
//   this.btncancelPopupName ="Cancel"
// }
confirmaccountNoErrMsgred(){
  try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
  if(!this.confirmaccountNo){this.confirmaccountNoErrMsg = true} else{this.confirmaccountNoErrMsg = false}}
transitNoErrMsgred(){
  try{this.transitNo=this.transitNo.trim()}catch{}
  if(!this.transitNo){this.transitNoErrMsg = true} else{this.transitNoErrMsg = false}}
financialInstitutionNoErrMsgred(){
  try{this.financialInstitutionNo=this.financialInstitutionNo.trim()}catch{}
  if(!this.financialInstitutionNo){this.financialInstitutionNoErrMsg = true} else{this.financialInstitutionNoErrMsg = false}}
accountNoErrMsgred(){
  //
  try{this.accountNo=this.accountNo.trim()}catch{}
  if(!this.accountNo){this.accountNoErrMsg = true} else{this.accountNoErrMsg = false}
}
confirmAccountNumberMatch: boolean=false;
accountConfirmFlag:boolean=false;
checkConfirmAccountNumber(){
  try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
  if(!this.confirmaccountNo){this.confirmaccountNoErrMsg = true} else{this.confirmaccountNoErrMsg = false}
  
  if(this.accountNo && this.confirmaccountNo){
    if(this.accountNo==this.confirmaccountNo){
      this.confirmAccountNumberMatch = false;
      this.accountConfirmFlag = false;
    }else{
      this.confirmAccountNumberMatch = true;
      this.accountConfirmFlag = false;
    }
  }
  
}
checkAccountNumber(){
  try{this.accountNo=this.accountNo.trim()}catch{}
  if(!this.accountNo){this.accountNoErrMsg = true} else{this.accountNoErrMsg = false}
  
  if(this.accountNo && this.confirmaccountNo){
    if(this.accountNo==this.confirmaccountNo){
      this.confirmAccountNumberMatch = false;
      this.accountConfirmFlag = false;
    }else{
      this.confirmAccountNumberMatch = true;
      this.accountConfirmFlag = false;
    }
  }
  
}
bankinfoChecked: boolean=false;
bankInfoErrmsg: boolean=false;
allowUser: boolean=false;
onBankInfoSelected(data){
  
  var checkFlag = data.target.checked;
  if(checkFlag == true){
    this.allowUser = true;
    this.bankInfoErrmsg = false;
    this.bankinfoChecked=true;
  }
  else{
    this.bankInfoErrmsg = true;
    this.allowUser = false;
    this.bankinfoChecked=false;
  }
}
cancelBtnPopup(){
   this.uploadVoidChequePopup =false;
   this.confirmAccountNumberMatch = false;
   this.confirmaccountNoErrMsg = false;
   this.accountNoErrMsg = false;
   this.financialInstitutionNoErrMsg = false;
   this.bankinfoChecked = false;
   this.transitNoErrMsg = false;
    this.bankInfoErrmsg = false;
    this.bankName = this.bankNm;
    this.transitNo = this.transitNm;
    this.financialInstitutionNo = this.financialInstNumber;
    this.accountNo = this.accNm;
    this.confirmaccountNo = this.accNm;
}
bankInfoPop(btnName){
  //
  this.bankinfoChecked = false;
  this.bankInfoErrmsg=false
  this.btnPopupName = btnName
  this.bankInfoErrmsg=false
  this.allowUser=false
}
removeFields(){
  this.transitNo = null;
  this.financialInstitutionNo = null;
  this.confirmaccountNo = null;
  this.accountNo = null;
  // this.fileId = null;
  this.fileenoName1 = null;
  this.confirmAccountNumberMatch = false;
  this.bankinfoChecked = false;
  this.uploadvoidchequeArray[0].fileeno1=null
    this.uploadvoidchequeArray[0].fileenoName1=null
}
closeBankInfoPopup(){
  //
  this.BankInfo = false;
  this.bankName = this.bankNm;
  this.transitNo = this.transitNm;
  this.financialInstitutionNo = this.financialInstNumber;
  this.accountNo = this.accNm;
  this.confirmaccountNo = this.accNm;
}
updateMgaShortName(){
  const request={
    "id": this.mgaId,
    "mgaShortName": this.mgaName,
  }
  this.user.submitFormService(this.config.updateMGAShortName, request).subscribe((data: any) => {
    this.editMGAShortName=false
    this.mgaName = data.data?.mgaShortName;
  }, err => {
  });
}
changeMGAShortName(){
  this.editMGAShortName =! this.editMGAShortName;
}
callMgaDoc(selectedmgaId,index){
  this.mgaIndex=index
     this.mgaId=selectedmgaId
     this.getMGADocuments(this.mgaId,this.mgaIndex);
     this.openTabs21(this.mgaIndex);
  this.callMgaAPI=true
}
getMGADocuments(MGAid,index){
    
    this.user.getMGAdocument(this.mgaId,this.leadId).pipe()
    .subscribe(
      data => {
        this.getDocuments=[];
        this.getLicences=[];
        this.getVoidCheck=[];
        if(data.data.documents != null){
          this.getDocuments.push(data.data.documents);
        }
        if(data.data.licences != null){
          this.getLicences = data.data.licences;
        }
        if (data.data.licences.length != 0) {
         
          for (var i = 0; i < data.data.licences.length; i++) {
            var obj = {}
            //this.uploadlicenseArray.push(data.data.licences[i]);
            try{obj["urltreamlic"] = data.data.licences[i].fileDownloadUrl.split('.').pop();}catch{}
            obj["createdAt"] = data.data.licences[i].createdAt;
            obj["createdBy"] = data.data.licences[i].createdBy;
            obj["description"] = data.data.licences[i].description;
            obj["expiryDate"] = data.data.licences[i].expiryDate;
            obj["fileDownloadUrl"] = data.data.licences[i].fileDownloadUrl;
            obj["fileId"] = data.data.licences[i].fileId;
            obj["fileUrl"] = data.data.licences[i].fileUrl;
            obj["id"] = data.data.licences[i].id;
            obj["lastModifiedBy"] = data.data.licences[i].lastModifiedBy;
            obj["licencesProvince"] = data.data.licences[i].licencesProvince;
            obj["licencesType"] = data.data.licences[i].licencesType;
            obj["licenseName"] = data.data.licences[i].licenseName;
            obj["licensesNumber"] = data.data.licences[i].licensesNumber;
            obj["status"] = data.data.licences[i].status;
            obj["type"] = data.data.licences[i].type;
            obj["updatedAt"] = data.data.licences[i].updatedAt;
            obj["provinceName"] = data.data.licences[i].provinces.provinceName;
            obj["provinceCode"] = data.data.licences[i].provinces.provinceCode;
            obj["isFirstTimeUpload"] = data.data.licences[i].isFirstTimeUpload;
            obj["isEditableDocument"] = data.data.licences[i].isEditableDocument;
            obj["effectiveDate"] = data.data.licences[i].effectiveDate;
           
            this.uploadlicenseArray.push(obj)
          }
          
         
        }
        if(data.data.accountDetails.length!=0){
          this.transitNo = data.data.accountDetails[0]?.transitNumber;
          this.financialInstitutionNo = data.data.accountDetails[0]?.finacialInstitutionNumber;
          this.accountNo = data.data.accountDetails[0]?.accountNumber;
          this.confirmaccountNo = data.data.accountDetails[0]?.accountNumber;
          this.maskaccountNo = data.data.accountDetails[0]?.accountNumber;
          this.eyeIconShowAccountNumber = data.data.accountDetails[0]?.accountNumberPlain;
        }
        else{
          this.transitNo =null;
          this.financialInstitutionNo=null;
          this.accountNo=null;
          this.confirmaccountNo =null;
          this.maskaccountNo =null;
          this.eyeIconShowAccountNumber =null;
        }
        if(data.data.accountDetails != null){
          this.getVoidCheck = data.data.accountDetails;
        }
      },error=>{
          },()=>{});
  }
  FileUploadMGA() {
    if(this.FileDataList!=undefined){
    for (var i = 0; i < this.FileDataList.length; i++) {
      this.productPhotofile = this.FileDataList[i];
      if (this.productPhotofile != null) {
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', this.expiryDate);
        formData.append('effectiveDate', this.effectiveDate);
        formData.append('leadId', this.leadId);
        // formData.append('agencyId',this.agencyId)
        formData.append('DocNumber',this.policyNumber)
        // formData.append('accountNumber',this.agencyId)
        // formData.append('bankNumber',this.policyNumber)
        formData.append('docName',this.fileenoName)
        formData.append('documentFor',"MGA")
        
        formData.append('documentType',this.documentType)
        formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
        formData.append('mgaId',this.mgaId)
        if(this.docId!=null || this.docFileId!=null){
          formData.append('documentId', this.docId)
          formData.append('fileId', this.docFileId)
          }
        // formData.append('province',this.agencyId)
        // formData.append('transitNumber',this.agencyId)
        //  this.fileData=formData
  
        this.uploadImagesMGA(formData)
      }
  
    }
  }else{
    this.overwriteEoMGATest()
        }
  }
  async uploadImagesMGA(formData: FormData) {
    this.loading = true;
    if(this.docId==null){
    this.user.submitFormService(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
      this.isOverWriteEO=false
      this.expiryDate = null;
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      this.uploadExpEOPopup = false;
      Swal.fire('', data.message, 'success');
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      // this.callAgencyApi=false;
      // this.callMgaAPI=true;
      this.openTabs21(this.mgaIndex);
      this.getMGADocuments(this.mgaId,this.mgaIndex)
  
    }, err => {
    });
  }else{
    this.user.OverWriteEO(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
      this.isOverWriteEO=false
      this.expiryDate = null;
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      this.docId=null;
  
      this.docFileId=null;
      this.uploadExpEOPopup = false;
      Swal.fire('', data.message, 'success');
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      // this.callAgencyApi=false;
      // this.callMgaAPI=true;
      this.openTabs21(this.mgaIndex);
      this.getMGADocuments(this.mgaId,this.mgaIndex)
    }, err => {
    });
  }
  }
  overwriteEoMGATest(){
  
    const formData = new FormData();
      formData.append('expiryDate', this.expiryDate);
      formData.append('effectiveDate', this.effectiveDate);
        formData.append('policyNumber', this.policyNumber);
        var data = this.leadId
        formData.append('leadId', data);
        // formData.append('agencyId',this.agencyId)
        formData.append('documentId', this.docId)
        formData.append('fileId', this.docFileId)
        formData.append('documentFor',"MGA")
        
        formData.append('documentType',this.documentType)
        formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
       
        formData.append('mgaId',this.mgaId)
    this.user.OverWriteEO(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
      this.isOverWriteEO=false
      this.expiryDate = null;
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      this.docId=null;
  
      this.docFileId=null;
      this.uploadExpEOPopup = !this.uploadExpEOPopup;
      Swal.fire('', data.message, 'success');
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      // this.callAgencyApi=false;
      // this.callMgaAPI=true;
      this.openTabs21(this.mgaIndex);
      this.getMGADocuments(this.mgaId,this.mgaIndex)
    }, err => {
    });
  }
  addLicMGA(){
    // this.fileIdlic=licval.fileId
    // this.province=licval.provinces.provinceCode
    // this.licenceId=licval.id;
    var obj={
      "expiryDateLic1":"",
      "provinceCode":undefined,
      "type":undefined,
      "licenseNumber":"",
      "filelicens":"",
      "lincencesName":""
       }
      this.uploadlicenseArray=[]
      this.uploadlicenseArray.push(obj)
      this.fileIdlic=null
      // this.fileenoNameLic=licval.licenseName,
      this.licenceId=null;
      
    }
    uploadlicensefileMGA(uploadlic, i) {
      this.oricid=uploadlic.oricDocumentId
      var flag = true
      var errormsg = [];
      uploadlic.expiryDate = this.DatePipe.transform(uploadlic.expiryDate, 'yyyy-MM-dd');
      uploadlic.effectiveDate = this.DatePipe.transform(uploadlic.effectiveDate, 'yyyy-MM-dd');
      //if(uploadlic.showemailErrorMsgone==true){}
      if (!uploadlic.filelicens || uploadlic.filelicens.length <= 0 || uploadlic.showemailErrorMsgone == true) { uploadlic.showemailErrorMsgone = true; flag = false; errormsg.push('Choose File') }
      if (!uploadlic.licenseNumber || uploadlic.licenseNumber.length <= 0) { uploadlic.showlicnErrorMsgone = true; flag = false; errormsg.push('Enter License Number') }
      // if(!uploadlic.licenseType || uploadlic.licenseType.length <= 0){uploadlic.showlictErrorMsgone = true;  flag=false; errormsg.push('License Type')} 
      if (!uploadlic.expiryDate || uploadlic.expiryDate.length <= 0) { uploadlic.showlicdErrorMsgone = true; flag = false; errormsg.push('Enter Expiry Date') }
      if (!uploadlic.province || uploadlic.province.length <= 0) { uploadlic.showlicpErrorMsgone = true; flag = false; errormsg.push('Select Province') }
      // if(!uploadlic.licenseName || uploadlic.licenseName.length <= 0){uploadlic.showlicnameErrorMsgone=true;  flag=false; errormsg.push('Provience')} 
    
      if (flag == true) {
        this.documentType="LICENSES"
        this.FileUploadLicMGA(uploadlic, i);
      }
      else {
        this.msg = errormsg.toString();
        this.msgfinal = this.msg.replace(",", '<br />');
        Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
      }
    }
    FileUploadLicMGA(uploadlic, k) {
    
      if(this.FileDataListLic!=undefined){
      for (var i = 0; i < this.FileDataListLic.length; i++) {
        this.productPhotofile = this.FileDataListLic[i];
        if (this.productPhotofile != null) {
          const formData = new FormData();
          formData.append('file', this.productPhotofile);
          formData.append('expiryDate', uploadlic.expiryDate);
          formData.append('effectiveDate', uploadlic.effectiveDate);
    
          formData.append('leadId', this.leadId);
          formData.append('DocNumber', uploadlic.licenseNumber);
          formData.append('docName', uploadlic.lincencesName);
          formData.append('licencesType', uploadlic.licencesType);
          formData.append('province', uploadlic.province);
          // formData.append('agencyId',this.agencyId)
          formData.append('documentFor',"MGA")
          
          formData.append('documentType',this.documentType)
          formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
         
          formData.append('mgaId',this.mgaId)
    if(this.fileIdlic!=null || this.licenceId!=null){
    formData.append('fileId', this.fileIdlic);
    formData.append('documentId', this.licenceId);
    }
     if(this.oricid!==null && this.oricid!=="" && (this.oricid!==undefined && this.oricid!=="undefined")){
          formData.append('oricDocumentId', this.oricid);
        }
          this.uploadImagesLicMGA(formData, k)
        }
    
      }
    }
    }
    async uploadImagesLicMGA(formData: FormData, k) {
      
      this.loading = true;
      if(this.licenceId==null){
      this.user.submitFormService(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
        this.loading = false;
        Swal.fire('', data.message, 'success');
        this.uploadnewLicensePopup = false;
        // this.callAgencyApi=false;
        // this.callMgaAPI=true;
        this.openTabs21(this.mgaIndex);
      this.getMGADocuments(this.mgaId,this.mgaIndex)
        //  this.showlicense=true;
        this.fileenoNameLic = "";
        this.uploadlicenseArray.splice(k, 1);
        this.uploadlicenseArray.push(data.data)
        this.isOverWriteEO=false
      }, err => {
    
      });
    }else{
      this.user.submitFormService1(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
        this.loading = false;
        this.licenceId=null;
         this.fileIdlic=null;
        Swal.fire('', data.message, 'success');
        // this.getDocument();
        this.uploadnewLicensePopup = false;
        // this.callAgencyApi=false;
        // this.callMgaAPI=true;
        this.openTabs21(this.mgaIndex);
      this.getMGADocuments(this.mgaId,this.mgaIndex)
        // this.showlicense=true;
        this.fileenoNameLic = "";
        this.uploadlicenseArray.splice(k, 1);
        this.uploadlicenseArray.push(data.data)
        this.isOverWriteEO=false
      }, err => {
    
      });
    }
    }
    FileUploadVoidMGA(item, k) {
      
        if(this.FileDataList1!=undefined){
        for (var i = 0; i < this.FileDataList1.length; i++) {
          this.productPhotofile1 = this.FileDataList1[i];
          if (this.productPhotofile1 != null) {
            const formData = new FormData();
            formData.append('file', this.productPhotofile1);
            formData.append('leadId', this.leadId);
            // formData.append('agencyId',this.agencyId)
            //  this.fileData=formData
         formData.append('accountNumber', this.accountNo);
      formData.append('confirmaccountNo', this.confirmaccountNo);
      formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
      formData.append('transitNumber', this.transitNo);
      formData.append('bankNumber',this.financialInstitutionNo)
            formData.append('documentFor',"MGA");
                formData.append('documentType',this.documentType)
                formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO));
                formData.append('mgaId',this.mgaId)
            if(this.fileIdvoid!=null || this.voidchequeId!=null){
              formData.append('fileId', this.fileIdvoid);
               formData.append('documentId', this.voidchequeId);
             
            }
              // this.fileData=formData
      
            this.uploadImagesvoidMGA(formData, k)
          }
      
        }
      }
      else{
        const formData = new FormData();
        // formData.append('file', this.productPhotofile1);
        var data = this.leadId
        formData.append('leadId', data);
        formData.append('documentFor',"MGA");
        formData.append('documentType',this.documentType)
        formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO));
        formData.append('mgaId',this.mgaId)
        formData.append('accountNumber', this.accountNo);
      formData.append('confirmaccountNo', this.confirmaccountNo);
      formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
      formData.append('transitNumber', this.transitNo);
      formData.append('bankNumber',this.financialInstitutionNo)
        //  this.fileData=formData
        if(this.fileIdvoid!=null || this.voidchequeId!=null){
          formData.append('fileId', this.fileIdvoid);
           formData.append('documentId', this.voidchequeId);
         
        }
      
      
        this.uploadImagesvoidMGA(formData, k)
      }
      }
      async uploadImagesvoidMGA(formData: FormData, k) {
      
      this.loading = true;
      if(this.fileIdvoid==null || this.voidchequeId==null){
      this.user.submitFormService(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
        this.isOverWriteEO=false
        this.finalDocs1 = data.data;
        this.loading = false;
        Swal.fire('', data.message, 'success');
        this.uploadVoidChequePopup = false;
        // this.callAgencyApi=false;
        // this.callMgaAPI=true;
        this.openTabs21(this.mgaIndex);
      this.getMGADocuments(this.mgaId,this.mgaIndex)
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)
      
      }, err => {
      
      });
      }else{
      this.user.submitFormService1(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
        this.isOverWriteEO=false
        this.finalDocs1 = data.data;
        this.loading = false;
        this.fileIdvoid=null;
        this.voidchequeId=null;
        Swal.fire('', data.message, 'success');
        this.uploadVoidChequePopup= false;
        // this.callAgencyApi=false;
        // this.callMgaAPI=true;
        this.openTabs21(this.mgaIndex);
      this.getMGADocuments(this.mgaId,this.mgaIndex)
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)
      
      }, err => {
      
      });
      }
      }
      uploadVoidMGA(item, i) {
        var flag = true
        var errormsg = [];
        if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
        if ( this.voidSizeCheck==true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Please upload the filesize less than 4MB')}
        // if(!this.expiryDate || this.expiryDate.length <= 0){this.showdateErrorMsg = true;  flag=false; errormsg.push('Date')} 
      
        if (flag == true) {
          this.documentType="VOID_CHEQUE"
          this.FileUploadVoidMGA(item, i);
      
        }
        else {
          this.msg = errormsg.toString();
          this.msgfinal = this.msg.replace(",", '<br />');
          Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
      
        }
      }
updateVoidChequeotpVerificationPopup:boolean=false;
  // otpVerificationPopup:boolean=false;
  // otpOfVoidCheque:any;
  // documentIdForOTPVerificationData:any=null;
  onClickOTPValidation1(item){
    //
    if(this.leadStatusStage == 'Activated'){
      this.otpOfVoidCheque=null;
      this.documentIdForOTPVerificationData=item;
      const request = {
        "documentId": this.documentIdForOTPVerificationData?.id,
        "otp": ""
      }    
      this.base.callPostService(this.config.checkAlreadyAuthoriseForVoidCheque, request).subscribe((data:any) =>{
        // if(data.status==true){
        //   this.onSelected1(this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.id,this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.fileDownloadUrl,this.documentIdForOTPVerificationData?.fileId)
        // }else{
          this.updateVoidChequeotpVerificationPopup=true;
          this.sendOtpForVoidCheque1();
        // }
      },error=>{{
      }},()=>{});
    }else{
      this.uploadVoidChequePopup = true;
    }
  }
  sendOtpForVoidCheque1(){
    const request = {
      "documentId": this.documentIdForOTPVerificationData?.id,
      "otp": ""
    }    
    this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
      if(data.status==true){
        this.startOtpTimer()
        this.toastr.success("Verification Code sent successfully.");
      }else{
        this.toastr.error(data.message);
      }
    },error=>{{
    }},()=>{});
  }
  verifyOTP1(){
    const request = {
      "documentId": this.documentIdForOTPVerificationData?.id,
      "otp": this.otpOfVoidCheque
    }    
    this.base.callPostService(this.config.verifyOtpForVoidCheque, request).subscribe((data:any) =>{
    if(data.status==true){
        this.uploadVoidChequePopup=true;
        this.updateVoidChequeotpVerificationPopup = false;
        // this.onSelected1(this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.id,this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.fileDownloadUrl,this.documentIdForOTPVerificationData?.fileId)
      }else{
        this.toastr.error("Incorrect Verification Code");
      }
    },error=>{{
    }},()=>{});
  }
  resendVoidChequeOTP1(){
    this.otpOfVoidCheque=null;
    this.updateVoidChequeotpVerificationPopup=true;
    const request = {
      "documentId": this.documentIdForOTPVerificationData?.id,
      "otp": ""
    }    
    this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
      if(data.status==true){
        this.startOtpTimer()
        this.toastr.success("Verification Code sent successfully.");
      }else{
        this.toastr.error(data.message);
      }
    },error=>{{
    }},()=>{});
  }
  eyeIconShowAccountNumber: boolean =false;
  eyeIcon: boolean=false;
  maskaccountNo: any;
  showAccountNumber(a) {
    //
    this.eyeIcon=!this.eyeIcon
    if (this.eyeIcon == true){
      if(a=='Confirm'){
        this.confirmaccountNo  = this.eyeIconShowAccountNumber;
      }
      if(a=='Account'){
        this.accountNo  = this.eyeIconShowAccountNumber;
      }  
    }else{
      if(a=='Confirm'){
        this.confirmaccountNo = this.maskaccountNo;
      }
      if(a=='Account'){
        this.accountNo  = this.maskaccountNo;
      }
    }
  }
  removeBankInfoErrMsg(){
    this.confirmAccountNumberMatch = false;
    this.confirmaccountNoErrMsg = false;
    this.accountNoErrMsg = false;
    this.financialInstitutionNoErrMsg = false;
    this.bankinfoChecked = false;
    this.transitNoErrMsg = false;
      this.bankInfoErrmsg = false;
      this.fileenoName1 = null;
      this.uploadvoidchequeArray[0].fileeno1=null
    this.uploadvoidchequeArray[0].fileenoName1=null
  }
 
  

  onEnterKeyPressed(event) {
    
    if (event.keyCode === 13 && !event.shiftKey) {
      this.verifyOTP();
    }
  }
  onEnterKeyPressedForVoidCheque(event) {
    
    if (event.keyCode === 13 && !event.shiftKey) {
      this.verifyOTP1();
    }
  }
  getProvince(){
    this.user.getProvince().pipe()
    .subscribe(
        data => {
          this.provinceArray=data.data;
        },error=>{
        },()=>{});
      }
      openDropDown1(a){
  
        if(a.type=="mouseleave"){
          this.showDropDown1=true;
        }
        this.showDropDown1=!this.showDropDown1;
        if(this.showDropDown1==false){
          this.showDropDown=false;
        }
      }
      closeDropDown(a){       
        this.showDropDown=false;
      }
      openDropDown(a){  
        this.showDropDown=true;
      }
      tabs21 = [
        { active21: '', tabcontent21: 'hide' }, // First tab is active by default
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
      ];
        openTabs21(index){
          //debugger
          this.reset21();
          this.reset2();
          this.reset22();
          this.tabs21[index].active21 = 'active21';
          this.tabs21[index].tabcontent21 = 'tabcontent21';
        }
        
        
        reset21() {
          for (let i = 0; i < this.tabs21.length; i++) {
            this.tabs21[i].active21 = '';  // Deactivate all tabs
            this.tabs21[i].tabcontent21 = 'hide';  // Hide all tab content
          }
        }
        tabs22 = [
          { active22: '', tabcontent22: 'hide' }, // First tab is active by default
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
        ];
          openTabs22(index){
            //debugger
            this.reset21();
            this.reset2();
            this.reset22();
            this.tabs22[index].active22 = 'active22';
            this.tabs22[index].tabcontent22 = 'tabcontent22';          
          }
          reset22() {
            for (let i = 0; i < this.tabs22.length; i++) {
              this.tabs22[i].active22 = '';  // Deactivate all tabs
              this.tabs22[i].tabcontent22 = 'hide';  // Hide all tab content
            }
          }
          getLastTrainingDate(){      
            this.user.getLastTrainingDate("LEAD",this.leadId).pipe()
            .subscribe(
                data => {
                  if(data.status==true){
                    this.lastTrainingDate=this.DatePipe.transform(data.data.sessionDate, "MM/dd/yyyy");                  
                  }
                  
                  
                },error=>{
                },()=>{});
              }
              startOtpTimer() {
                this.remainingSecondsSIN = 300; // 5 minutes = 300 seconds
                this.isOtpExpiredSIN = false;
                this.updateTimerDisplay();
              
                if (this.otpTimerSIN) {
                  clearInterval(this.otpTimerSIN);
                }
              
                this.otpTimerSIN = setInterval(() => {
                  if (this.remainingSecondsSIN > 0) {
                    this.remainingSecondsSIN--;
                    this.updateTimerDisplay();
                  } else {
                    //debugger
                    this.isOtpExpiredSIN = true;
                    clearInterval(this.otpTimerSIN);
                  }
                }, 1000);
              }
              
              updateTimerDisplay() {
                const minutes = Math.floor(this.remainingSecondsSIN / 60);
                const seconds = this.remainingSecondsSIN % 60;
                this.otpTimerDisplaySIN = `${this.pad(minutes)}:${this.pad(seconds)}`;
              }
              
              pad(value: number): string {
                return value < 10 ? '0' + value : value.toString();
              }
}